var _defs, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyvisualLgRgb = function SvgKeyvisualLgRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1140,
    height: 360,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1140 360",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_2",
    cx: 116.82,
    cy: 126.2,
    fx: 116.82,
    fy: 126.2,
    r: 44.16,
    gradientTransform: "translate(494.51) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffecde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ec2a37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ee454b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f16a67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f5998c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f9d2b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf4d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_79",
    cx: 247.94,
    cy: 412.57,
    fx: 247.94,
    fy: 412.57,
    r: 40.99,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f7fafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e0edf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b7d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#73bce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58b3e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_78",
    x1: 1217.79,
    y1: 83.6,
    x2: 1275.97,
    y2: 83.6,
    gradientTransform: "translate(-736.95 -469.54) rotate(30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d1e1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c2d0da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#abb5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8c9398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_76",
    cx: 242.81,
    cy: 403.26,
    fx: 242.81,
    fy: 403.26,
    r: 42.62,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f9fcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e9f2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e1edd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_77",
    cx: 281.59,
    cy: 445.41,
    fx: 281.59,
    fy: 445.41,
    r: 42.87,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f6f3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e6efd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1edd8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_42",
    x1: 547.43,
    y1: 1587.65,
    x2: 547.43,
    y2: 1465.74,
    gradientTransform: "translate(1239.87 -1354.42) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbfb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdd7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fee8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fef2bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_41",
    x1: 805.71,
    y1: 6239.78,
    x2: 805.71,
    y2: 6192.53,
    gradientTransform: "translate(0 -6098.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dfecf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffecde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_43",
    x1: -366.52,
    y1: -3469.49,
    x2: -366.52,
    y2: -3517.05,
    gradientTransform: "translate(678.61 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#444a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#465374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#475b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#49619b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4a65a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4a68ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b69b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_75",
    x1: -692.31,
    y1: -3567.37,
    x2: -663.44,
    y2: -3567.37,
    gradientTransform: "translate(-1135.71 -2794.7) rotate(-44.97) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#b6d8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#90c6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#74b9d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#63b0d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eaed6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_74",
    x1: -712.18,
    y1: -3538.35,
    x2: -655.57,
    y2: -3571.02,
    gradientTransform: "translate(-1135.71 -2794.7) rotate(-44.97) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d2e6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cbe3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#beddd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#acd4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#95c9d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#79bbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eaed6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_73",
    x1: 910.77,
    y1: -3442.67,
    x2: 921.19,
    y2: -3436.65,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b68b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#627ab1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5afb5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#d5d5b8",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f3edba",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6bb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_65",
    x1: 197.74,
    y1: -3366.43,
    x2: 197.74,
    y2: -3482.96,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_64",
    x1: 190.84,
    y1: -3469.8,
    x2: 190.84,
    y2: -3458.68,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#faf0b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f2e2ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e3cb99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#cfaa7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b5815f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab7152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_64-2",
    x1: 190.92,
    y1: 178.63,
    x2: 190.92,
    y2: 189.75,
    gradientTransform: "translate(0 58.63)",
    xlinkHref: "#Unbenannter_Verlauf_64"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_63",
    cx: 191.65,
    cy: -3419.46,
    fx: 191.65,
    fy: -3419.46,
    r: 9.21,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef5bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_62",
    x1: 190.82,
    y1: -3438.97,
    x2: 190.82,
    y2: -3420.4,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fbf1b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f4e5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e8d29f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d7b88a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c2966f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab7152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_60",
    x1: 151.73,
    y1: -3463.06,
    x2: 184.02,
    y2: -3463.06,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ebefc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dae9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_58",
    x1: 179.8,
    y1: -3515.36,
    x2: 193.1,
    y2: -3515.36,
    gradientTransform: "translate(0 -3205.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4967ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4767ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_58-2",
    x1: 147.96,
    y1: -3515.46,
    x2: 161.1,
    y2: -3515.46,
    xlinkHref: "#Unbenannter_Verlauf_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_72",
    x1: 575.39,
    y1: -3513.13,
    x2: 554.04,
    y2: -3513.13,
    gradientTransform: "translate(128.46 3820.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#cedeea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8d9599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_72-2",
    x1: 575.06,
    y1: -3526.59,
    x2: 561.56,
    y2: -3526.59,
    gradientTransform: "translate(1257.89 -3205.7) rotate(-180)",
    xlinkHref: "#Unbenannter_Verlauf_72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_71",
    x1: 539.23,
    y1: -3498.41,
    x2: 543.01,
    y2: -3504.96,
    gradientTransform: "translate(175.66 3797.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_70",
    x1: 528.97,
    y1: -3475.3,
    x2: 540.44,
    y2: -3506.98,
    gradientTransform: "translate(1257.89 -3205.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_69",
    x1: 520.46,
    y1: -3526.57,
    x2: 559.72,
    y2: -3526.57,
    gradientTransform: "translate(1257.89 -3205.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d6e7f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_69-2",
    x1: 569.74,
    y1: -3539.23,
    x2: 581.34,
    y2: -3539.23,
    xlinkHref: "#Unbenannter_Verlauf_69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_61",
    x1: 1002.95,
    y1: -3399.28,
    x2: 1002.95,
    y2: -3452.95,
    gradientTransform: "translate(1759.32 -3205.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cabf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f7bdb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f39b96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ec6466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb5b5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_46",
    x1: 1975.38,
    y1: -2018.65,
    x2: 1970.36,
    y2: -1990.52,
    gradientTransform: "translate(708.5 -2557.76) rotate(133.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f5f2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dbe9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d6e8f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_68",
    x1: 1171.98,
    y1: -3473.6,
    x2: 1178.03,
    y2: -3470.11,
    gradientTransform: "translate(1711.75 -3205.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#faefe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f3e8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e6dcd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#d3cbc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#bbb5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9d9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7a787d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#52535d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484a55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_67",
    x1: 359.61,
    y1: -3823.87,
    x2: 359.61,
    y2: -3781.47,
    gradientTransform: "translate(2430.72 -2971.05) rotate(-154.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d4e5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cedfeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c5d4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b7c4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a5b0b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8f979d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#74797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#575758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_66",
    x1: 1135.71,
    y1: -3541.87,
    x2: 1135.71,
    y2: -3495.23,
    gradientTransform: "translate(1711.75 -3205.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4967ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#48609a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#465883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#454d63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44454b"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 374.47,
    y: 166.24,
    width: 6.85,
    height: 117.13,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.63,183.51l-24.37,1.48,16.37,18.38c.99.41,1.81,1.22,3,1.71,5.54,2.3,12.17-.28,14.55-6.02,2.38-5.74-.28-12.17-6.02-14.55-5.74-2.38-1.58-.66-3.53-1",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.26,
    y1: 184.99,
    x2: 373.28,
    y2: 199.1,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.16,229.78l24.61.35-15.77,19.15c-.88.65-1.76,1.29-2.93,1.83-5.63,2.62-12.26.04-14.79-5.39-2.53-5.44-.04-12.26,5.39-14.79,5.44-2.53,1.75-.81,3.48-1.15",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.73,
    y1: 229.8,
    x2: 381.86,
    y2: 245.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.53 83.7 388.39 88.73 387.96 95.79 387.96 99.43 393.95 93.65 401.77 90.44 409.05 95.15 412.26 100.93 410.98 106.93 405.84 113.14 403.48 114.53 411.62 114.74 415.9 116.03 420.83 120.74 422 127.81 418.69 134.44 410.98 137.01 403.48 136.58 411.19 143.97 412.48 150.4 410.76 154.89 406.05 158.75 402.63 159.82 396.84 159.82 392.67 155.53 388.81 151.89 388.81 158.53 388.17 162.6 383.46 168.49 379.61 170.2 374.47 170.2 370.4 167.42 367.08 162.6 366.22 152.32 361.09 157.68 358.52 159.39 353.16 160.46 347.17 157.68 343.74 152.32 343.74 146.33 350.59 136.58 342.46 136.58 338.28 135.09 334.86 131.02 333.36 125.02 337.85 116.67 343.31 114.96 352.09 115.6 345.03 109.07 343.31 102.86 344.6 96.65 348.02 92.8 354.66 90.44 360.23 91.94 364.08 96.01 366.87 99.22 366.65 90.44 369.76 84.55 375.11 82.2 378.54 82.2 382.61 82.84 384.53 83.7",
    style: {
      fill: "url(#Unbenannter_Verlauf_2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.91,114.96l5.14-5.14c4.28-4.28,4.28-11.13,0-15.52-4.28-4.28-11.13-4.28-15.52,0l-4.71,4.71",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,152.11l-4.71,4.92c-4.28,4.28-11.13,4.28-15.52,0-4.39-4.28-4.28-11.13,0-15.52l4.92-4.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,152.32l4.71,4.71c4.28,4.28,11.13,4.28,15.52,0,4.5-4.28,4.28-11.13,0-15.52l-5.14-5.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,114.96l-5.14-5.14c-4.28-4.28-4.28-11.13,0-15.52,4.28-4.28,11.13-4.28,15.52,0l4.92,4.71",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,125.88v-33.3c0-6-4.92-10.92-10.92-10.92-6,0-10.92,4.92-10.92,10.92v33.3s21.95,0,21.95,0h-.21s.11,0,.11,0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,125.88v33.3c0,6-4.92,10.92-10.92,10.92-6,0-10.92-4.92-10.92-10.92v-33.3h21.95s-.21,0-.21,0h.11Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,136.58h33.3c6,0,10.92-4.92,10.92-10.92s-4.92-10.92-10.92-10.92h-33.3s0,21.95,0,21.95h0v-.21s0,.11,0,.11Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,136.58h-33.3c-6,0-10.92-4.92-10.92-10.92s4.92-10.92,10.92-10.92h33.3v21.95h0v-.21s0,.11,0,.11Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.61,
    y1: 142.47,
    x2: 379.61,
    y2: 157.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.4,
    y1: 145.68,
    x2: 376.4,
    y2: 160.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.68,
    y1: 93.87,
    x2: 378.54,
    y2: 108.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.25,
    y1: 94.29,
    x2: 375.75,
    y2: 103.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.16,
    y1: 141.19,
    x2: 355.09,
    y2: 148.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.16,
    y1: 141.19,
    x2: 354.02,
    y2: 144.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.34,
    y1: 105,
    x2: 390.31,
    y2: 113.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.15,
    y1: 113.14,
    x2: 355.95,
    y2: 103.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.73,
    y1: 105,
    x2: 356.38,
    y2: 99.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.56,
    y1: 149.75,
    x2: 392.46,
    y2: 140.55,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.13,
    y1: 153.82,
    x2: 395.56,
    y2: 148.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.83,
    y1: 125.88,
    x2: 394.92,
    y2: 125.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.41,
    y1: 130.37,
    x2: 394.92,
    y2: 128.23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.55,
    y1: 120.31,
    x2: 397.27,
    y2: 122.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 125.88,
    x2: 346.95,
    y2: 125.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 122.67,
    x2: 349.95,
    y2: 120.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.89,
    cy: 125.88,
    r: 18.95,
    style: {
      fill: "#fcf4d1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.41,
    y: 266.64,
    width: 3.98,
    height: 10.65,
    style: {
      fill: "#020202",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.07,
    y: 257.37,
    width: 8.14,
    height: 2.43,
    transform: "translate(-98.87 345.92) rotate(-60)",
    style: {
      fill: "#020202",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.58,
    y: 164.78,
    width: 8.14,
    height: 2.43,
    transform: "translate(8.07 345.96) rotate(-60)",
    style: {
      fill: "#020202",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.84,
    cy: 211.72,
    r: 51.71,
    style: {
      fill: "url(#Unbenannter_Verlauf_79)",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,161.4c27.8,16.02,37.33,51.62,21.31,79.43-16.02,27.8-51.62,37.33-79.43,21.31h0l1.91-3.29c25.99,14.98,59.25,6.06,74.23-19.92,14.98-25.99,6.06-59.25-19.92-74.23l1.91-3.29",
    style: {
      fill: "url(#Unbenannter_Verlauf_78)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.38,
    y: 277.29,
    width: 54.05,
    height: 3.98,
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.14,
    y: 281.36,
    width: 62.45,
    height: 1.99,
    style: {
      fill: "#020202",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.01,171.96c.78.69,1.56,1.47,2.34,2.17,1.13,1.04,2.25,2.08,3.29,3.29,2.08,2.34,3.72,4.94,5.37,7.62.43.78.87,1.04,1.21,1.82.17-.09.26.69.35.87,2.17,4.5,3.98,9.09,4.85,14.03.17.87.26,1.73.43,2.6.09.52.17,1.04.17,1.56.26,2.08.52,4.16.35,6.24-.43.17-.87.43-1.3.78-.09.09-.26.26-.43.26h-.43c-.17,0-.35.17-.43.26-.26.26-.52.43-.78.69-.09.09-.26.17-.35.26s-.35-.09-.35-.17c-.69.78-1.3,1.73-1.82,2.6.35.17.43.61.43.95s-.09.78.09,1.13c.09.17.17.26.26.35.09.17.17.35.17.52.26,1.13.43,2.43-.09,3.46-.09.17-.17.35-.35.43s-.43,0-.43-.17c-.09-.17,0-.35-.17-.35-.35,0-.52.26-.78.52-.26.26-.61.43-.78.09-.09-.17-.17-.52-.35-.43,0-1.13,0-2.34-.09-3.46-.09,0-.17-.09-.26-.09h-.17c-.09.09-.26.17-.35.09-.17-.09-.26-.26-.35-.43-.26-.26-.78,0-1.13-.17-.35-.17-.35-.78-.26-1.21.09-.52.26-1.04.35-1.56,0-.17.09-.35-.09-.43-.09-.09-.26,0-.43-.09s-.26-.35-.26-.61c-.09-1.21-.26-2.43-.35-3.64q0-.09-.09-.17c-.09-.17-.43-.09-.52.09-.17.17-.26.43-.43.43s-.26-.09-.43-.09c-.35-.09-.61.17-.78.43s-.26.61-.43.87c-.26.35-.61.43-.95.69-.35.17-.69.52-.69.95-.09,0-.17-.17-.09-.26-.43.95-1.91,1.13-2.43,2.17-.17.26-.17.61-.35.95-.35.87-1.3,1.39-1.56,2.25-.17.52-.09,1.04,0,1.56.17,1.47,0,2.94-.61,4.24-.09.17-.26.35-.43.26s-.17-.43-.35-.35c0,.26-.35.35-.61.17-.17-.17-.26-.43-.17-.69s.17-.43.35-.69c.43-.78.35-1.82-.09-2.51-.43.26-.52.78-.69,1.3s-.43,1.04-.95.95v-1.21c0-.09,0-.17-.09-.17s-.17,0-.17.09c.69-1.04.17-2.43.43-3.64.09-.17.09-.43.09-.61s-.09-.43-.35-.52c.43-1.04.17-2.25.26-3.38,0-.52.09-1.04.17-1.47.09-.78.17-1.56.35-2.34-.35.17-.87.26-1.04-.09-.09.17-.43.09-.61,0-.26-.17-.61-.17-.87-.43-.61-.69-.35-1.82-.43-2.69-.09-1.39-1.04-2.6-2.34-3.03-.26-.09-.43-.17-.61-.35-.09-.17-.17-.35-.26-.43-.17-.26-.52-.35-.87-.35-.52,0-1.04-.09-1.65-.09-.43,0-.95-.09-1.39-.26-.61-.26-.95-.78-1.39-1.3-.09-.09-.17-.26-.17-.35-.09-.26.09-.52.09-.78,0-.43-.43-.69-.87-.78s-.87,0-1.21-.17c-.69-.26-1.13-.95-1.47-1.65s-.61-1.47-1.3-1.82c-.61-.35-1.73-.09-1.73.69,0,.52.35.87.43,1.39,0,.26,0,.52.09.69.09.17.26.26.35.43.26.35,0,.87-.09,1.21-.17.43-.09,1.04.35,1.04.69.09,1.3.17,1.99.26.17,0,.35,0,.43-.09.17-.09.26-.43.43-.52.35-.17.69.17.69.52s-.09.78,0,1.04c.09.26.35.43.52.61.43.35.95.69,1.3,1.13s.61,1.04.43,1.65c-.17.43-.52.78-.95,1.13-.95.78-1.82,1.56-2.77,2.25-.17.09-.26.26-.43.26-.26.09-.52,0-.78,0-2.69-.43-5.72-.09-8.32.87.09,0,0-.09.09-.09-.17-.52-1.04-.43-1.56-.61l.09.17c-.17-.17-.43-.26-.61-.17,0-.17-.09-.35-.09-.43-.17.09-.35,0-.43-.17s-.09-.35-.09-.52c.09-1.21.09-2.51.52-3.72.09-.26.17-.52.17-.87,0-.61-.35-1.3-.26-1.91-.26.09-.43-.26-.43-.52s-.09-.61-.35-.69h-.26c-.26-.09-.17-.43-.09-.69.17-.61-.09-1.3-.09-1.99,0-.43.09-.95.09-1.39,0-1.3-.69-2.6-1.91-3.12-.09,0-.09-.09-.17-.09-.17,0-.26.17-.26.26-.26.43-.43.87-.69,1.3-.09.26-.26.43-.26.69,0,.17,0,.35.09.43.17.69.35,1.39.61,1.99.09.17.26.43.43.35-.09.52-.26,1.13-.52,1.56.17.61.35,1.21.26,1.82-.09.26-.17.52-.17.78-.35,1.39.09,2.86.52,4.24,0,.09.09.17.17.26.09.09.26.17.35.26.26.26.09.78.43.87-.17.26-.35.52-.35.87s.35.61.61.52c-.09.78,0,1.56.61,1.99.09-.09.17-.17.35-.17.09.17.17.26.26.43.43-.09.78.26,1.04.61.09,0,.17-.09.26-.09,1.47.35,3.29-1.13,4.42-.09.52.43.52,1.3.26,1.91s-.78,1.13-1.3,1.65c-1.04,1.04-2.17,2.08-3.2,3.12-.87.78-1.73,1.65-2.86,1.91-.43.09-.87.09-1.3.17-.69.09-1.39.52-1.99.87-1.65.95-3.29,1.91-4.94,2.86-.43.26-.87.52-1.13.95-.35.61-.17,1.3-.09,1.91.26,3.03-2.08,6.15-5.11,6.67-.52.09-1.04.09-1.47.43-.26.26-.43.61-.52.87-.35.95-.69,2.17-1.65,2.6-.43.26-1.04.26-1.47.43-1.91.61-2.6,3.12-4.42,3.9-1.47.61-3.12-.09-4.33-1.04-1.73-1.47-2.69-3.55-3.38-5.72-.52-1.56-.87-3.12-1.21-4.68-.43-1.91-.95-4.24-1.39-6.15.17-.52,0-1.13-.35-1.56,1.99-1.82,4.07-3.98,4.07-6.67,0-1.91-.95-3.72-.61-5.54.09-.61.35-1.13.35-1.65,0-.61-.17-1.3.09-1.91.26-.52.78-.69,1.13-1.13.95-1.04.17-2.94-1.21-3.12-.43-.09-.87,0-1.21-.17-.87-.52-.09-2.17-.95-2.86-.61-.52-1.56.09-2.34.17-1.04.09-1.99-.78-2.6-1.65s-1.04-1.91-1.91-2.51c-.17-.17-.43-.26-.52-.43-.09-.26-.09-.52,0-.78.52-2.17,1.04-4.42,1.65-6.58.26-1.21.61-2.43,1.3-3.46.35-.52.78-.95,1.21-1.39.78-.95,1.39-1.99,2.08-3.03.78-.95,1.73-1.91,2.94-2.08,1.13-.26,2.43.09,3.38-.52.52-.35.87-.87,1.39-1.3,1.56-1.47,4.24-.95,6.24-.61,1.13.17,2.69.61,4.5,1.47.95,0,2.08.17,2.34.78.35.69-.43,1.3-.52,2.25-.17,1.04.52,2.51,3.81,4.68.09-.61,1.39-.78,1.82-.35.52.43.69,1.04,1.13,1.56.26.35.52.61.95.78,1.13.61,2.69.61,3.2,1.73.09.26.17.52.35.61.35.17.69-.17.87-.43s.69-.52.95-.26c.09.17.09.35.17.52.17.26.52.43.87.35.43-.09.69-.43.87-.52.43-.52,2.94-1.65,2.86-2.34-.09-.69-3.81-1.82-4.5-1.82-.17,0-.78.09-1.04-.26-.17-.17-.17-.52-.17-.78,0-.52.09-1.13.35-1.56.09-.17.26-.26.35-.43.09-.26-.09-.43-.26-.61-.35-.43-.69-.87-1.13-1.13-.52-.26-1.13-.26-1.47.17-.26.35-.17.61-.43.95-.17.26-.43.78-1.13.26s.09-2.25.35-2.77c.09-.17.26-.43.26-.69,0-.61-.69-1.04-1.04-1.56-.26-.52-.26-1.13-.52-1.65-.26-.52-.95-.95-1.39-.52s0,1.13.26,1.65c.26.43.35.95.26,1.47-.09.78-.78,1.73-1.56,1.39-.52-.17-.69-.78-.69-1.3s.17-1.04.26-1.56c.09-.61-.09-1.3-.43-1.82-.09-.17-.26-.35-.43-.35s-.35.09-.52.17c-1.21.61-2.6-.69-3.9-.52-.43.09-.87.26-1.3.43-1.21.52-2.6.61-3.9.78-.95.09-2.25,0-2.6-.87s.35-1.73,1.04-2.34c.52-.43.95-.95,1.47-1.39.35-.35.78-.69,1.3-.87s1.13-.09,1.39.35c.17.26.26.69.43,1.04.26.52.95.61,1.47.52.52-.09.87-.17,1.56-.61.35-.17.61-.35.78-.52,0,0,.09-.09.17-.17.17-.17.26-.17.35-.35.26-.26.09-.43.26-.69.17-.17.35-.26.43-.26.17,0,.35,0,1.04.26.43.17.61.35.87.26.35-.09.43-.52.35-.78s-.35-.52-.61-.78c-.35-.35.26-1.04.69-1.13.52-.09.95.09,1.47-.17s.78-.78,1.13-1.3c.35-.43,1.04-.87,1.47-.52,0,.69-.35,1.3-.87,1.65-.26.17-.61.35-.78.61-.17.26-.09.78.26.78-.35.43-.69,1.21-.26,1.56.17.17.43.17.52.17.87,0,1.73,0,2.6-.09.17,0,.43,0,.61.17.09.09.09.17.17.26.26.26.69-.26,1.13-.17,3.03.87-1.39-.95.61.95.17.17.52.17.78.17,1.56-.09,3.12-.35,4.68-.61.26-.09.52-.09.78-.17h2.17c.26,0,.61.09.69.35.09-.09.26-.17.35-.09,0-.26.35-.35.61-.26.26.09.52.26.78.17.35-.09.87-.87.69-1.13s-.61-.26-.95-.17c-.35.09-.61.26-.95.35-.52.09-1.04-.35-1.47-.69-.09-.09-.26-.17-.26-.35-.09-.26.17-.52.43-.61.26-.09.61-.09.87-.17.26-.09.52-.35.43-.52-.09-.26-.43-.26-.61-.17-.43,0-.87.09-1.3.17-.35,0-.78-.09-1.13.17-.17.09-.35.35-.52.43-.26.26-.61.43-.95.52-.87.35-1.73.52-2.69.69h-.35c-.26-.17-.35-.69-.69-.69.26-.35.61-.69.87-1.04,0-.09-.17-.17-.35-.17s-.26.09-.35.17c-.43.17-.87.09-1.13-.26-.09,0-.17-.17-.09-.35.87-.87,1.99-1.3,3.2-1.3.09,0,.26,0,.35.09s.17.17.26.17h.26c.26-.09.43.09.69.09h.43c.69-.09,1.13,0,1.91-.09.52.09,1.04.09,1.47-.17.52.52,1.39.26,2.08.43.69.17,1.21.61,1.82.87.43.09.87.09,1.3.17.43.09.52.61.69.95.17.17.17.52.43.61.09.09.17.09.26.09.26.17.17.52,0,.69s-.52.26-.78.17c-.26,0-.17-.43-.43-.43-.09.26-.09.52,0,.78.09.26,0,.78.26.78.35,0,.61-.26.87-.43.35-.26.87-.35,1.3-.26,1.47.17,3.03-.95,4.24-.09.26.17.43.35.69.43.61.26,1.39-.17,2.08.09.52.17.95.78,1.47.61.43-.17.52-.69.95-.78.43-.09.78.52,1.13.78.43.35,1.13.17,1.39-.26.09-.17.17-.35.35-.52.26-.17.61-.17.87,0s.43.43.61.61c.35.35,1.39.78,3.64.61",
    style: {
      fill: "url(#Unbenannter_Verlauf_76)",
      stroke: "url(#Unbenannter_Verlauf_77)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06,241.43c-.43.52-.17,1.39.35,1.82s1.3.43,1.99.43c.43,0,.78-.09,1.13-.26.61-.35.87-1.04,1.21-1.56.95-1.56,2.51-2.69,3.64-3.98.52-.61,1.47-1.65,1.13-2.51-.43-1.13-1.04-.43-1.47.09-1.04.95-1.56,1.13-3.03.95-1.21-.09-1.99-.26-2.6.95-.43.78-.87,1.65-1.21,2.43-.17.43-.09.69-.35,1.13-.09.17-.52.26-.78.52Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,231.64c.09.26.35.43.43.61.17.35.09.69.09,1.04-.17,1.3-.26,2.69-.61,3.98-.09.52-.26,1.13.17,1.47.43.35,1.13,0,1.39-.43.26-.52.35-1.04.69-1.56.17-.26.43-.52.69-.78.17-.26.35-.69.17-.95-.17-.43-.87-.61-.87-1.04,0-.35.26-.61.17-.95-.09-.17-.52-.43-.61-.78-.17-.61.26-1.3.09-1.91-.78-2.77-2.69-.26-1.82,1.3Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,228.96c.09.26.09.61.09.87,0,.69.09,1.3.35,1.91.09.17.17.35.43.43s.52-.26.52-.61-.17-.61-.26-.87-.09-.69.17-.87c.09-.09.26-.17.43-.17.43-.26.52-.87.26-1.21-.17-.26-.52-.35-.69-.52-.78-.61-.87-1.65-.52-2.51-.52,0-1.13.61-1.39,1.04-.87,1.3.17,1.47.61,2.51Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.99,223.76c-1.13.43-2.08,1.47-2.34,2.69-.17.61-.17,1.3-.26,1.91-.52,2.69-3.03,4.42-4.33,6.76-.09-.09.09-.17.17-.09.09.09,0,.17,0,.26-.17.52-.35,1.13-.43,1.65.78.61,1.04,1.82.61,2.77,1.47-2.08,2.77-4.42,3.72-6.76.52-1.3,1.04-2.6,1.56-3.98.52-1.73,1.3-3.46,1.3-5.2Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,241.17c-.52,0-1.13.17-1.56.52-.09.09-.26.17-.43.26-.17.09-.43,0-.61,0-.52,0-.78.61-.87,1.13-.26,1.21-.26,2.51-.87,3.64-.09-.09.09-.09.17-.26,1.73-1.56,3.12-3.29,4.16-5.28Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87,210.77c-.17-.17-.43-.26-.61-.17,0-.17-.09-.35-.09-.43-.17.09-.35,0-.43-.17s-.09-.35-.09-.52c.09-1.21.09-2.51.52-3.72.09-.26.17-.52.17-.87,0-.61-.35-1.3-.26-1.91-.26.09-.43-.26-.43-.52s-.09-.61-.35-.69h-.26c-.26-.09-.17-.43-.09-.69.17-.61-.09-1.3-.09-1.99,0-.43.09-.95.09-1.39,0-1.3-.69-2.6-1.91-3.12-.09,0-.09-.09-.17-.09-.17,0-.26.17-.26.26-.26.43-.43.87-.69,1.3-.09.26-.26.43-.26.69,0,.17,0,.35.09.43.17.69.35,1.39.61,1.99.09.17.26.43.43.35-.09.52-.26,1.13-.52,1.56.17.61.35,1.21.26,1.82-.09.26-.17.52-.17.78-.35,1.39.09,2.86.52,4.24,0,.09.09.17.17.26.09.09.26.17.35.26.26.26.09.78.43.87-.17.26-.35.52-.35.87s.35.61.61.52c-.09.78,0,1.56.61,1.99.09-.09.17-.17.35-.17.09.17.17.26.26.43.43-.09.78.26,1.04.61.09,0,.17-.09.26-.09,1.47.35,3.29-1.13,4.42-.09.52.43.52,1.3.26,1.91s-.78,1.13-1.3,1.65c-1.04,1.04-2.17,2.08-3.2,3.12-.87.78-1.73,1.65-2.86,1.91-.43.09-.87.09-1.3.17-.69.09-1.39.52-1.99.87-1.65.95-3.29,1.91-4.94,2.86-.43.26-.87.52-1.13.95-.35.61-.17,1.3-.09,1.91.26,3.03-2.08,6.15-5.11,6.67-.52.09-1.04.09-1.47.43-.26.26-.43.61-.52.87-.35.95-.69,2.17-1.65,2.6-.43.26-1.04.26-1.47.43-1.91.61-2.6,3.12-4.42,3.9-1.47.61-3.12-.09-4.33-1.04-1.73-1.47-2.69-3.55-3.38-5.72-.52-1.56-.87-3.12-1.21-4.68-.43-1.91-.95-4.24-1.39-6.15.17-.52,0-1.13-.35-1.56,1.99-1.82,4.07-3.98,4.07-6.67,0-1.91-.95-3.72-.61-5.54.09-.61.35-1.13.35-1.65,0-.61-.17-1.3.09-1.91.26-.52.78-.69,1.13-1.13.95-1.04.17-2.94-1.21-3.12-.43-.09-.87,0-1.21-.17-.87-.52-.09-2.17-.95-2.86-.61-.52-1.56.09-2.34.17-1.04.09-1.99-.78-2.6-1.65s-1.04-1.91-1.91-2.51c-.17-.17-.43-.26-.52-.43-.09-.26-.09-.52,0-.78.52-2.17,1.04-4.42,1.65-6.58.26-1.21.61-2.43,1.3-3.46.35-.52.78-.95,1.21-1.39.78-.95,1.39-1.99,2.08-3.03.78-.95,1.73-1.91,2.94-2.08,1.13-.26,2.43.09,3.38-.52.52-.35.87-.87,1.39-1.3,1.56-1.47,4.24-.95,6.24-.61,1.13.17,2.69.61,4.5,1.47.95,0,2.08.17,2.34.78.35.69-.43,1.3-.52,2.25-.17,1.04.52,2.51,3.81,4.68.09-.61,1.39-.78,1.82-.35.52.43.69,1.04,1.13,1.56.26.35.52.61.95.78,1.13.61,2.69.61,3.2,1.73.09.26.17.52.35.61.35.17.69-.17.87-.43s.69-.52.95-.26c.09.17.09.35.17.52.17.26.52.43.87.35.43-.09.69-.43.87-.52.43-.52,2.94-1.65,2.86-2.34-.09-.69-3.81-1.82-4.5-1.82-.17,0-.78.09-1.04-.26-.17-.17-.17-.52-.17-.78,0-.52.09-1.13.35-1.56.09-.17.26-.26.35-.43.09-.26-.09-.43-.26-.61-.35-.43-.69-.87-1.13-1.13-.52-.26-1.13-.26-1.47.17-.26.35-.17.61-.43.95-.17.26-.43.78-1.13.26s.09-2.25.35-2.77c.09-.17.26-.43.26-.69,0-.61-.69-1.04-1.04-1.56-.26-.52-.26-1.13-.52-1.65-.26-.52-.95-.95-1.39-.52s0,1.13.26,1.65c.26.43.35.95.26,1.47-.09.78-.78,1.73-1.56,1.39-.52-.17-.69-.78-.69-1.3s.17-1.04.26-1.56c.09-.61-.09-1.3-.43-1.82-.09-.17-.26-.35-.43-.35s-.35.09-.52.17c-1.21.61-2.6-.69-3.9-.52-.43.09-.87.26-1.3.43-1.21.52-2.6.61-3.9.78-.95.09-2.25,0-2.6-.87s.35-1.73,1.04-2.34c.52-.43.95-.95,1.47-1.39.35-.35.78-.69,1.3-.87s1.13-.09,1.39.35c.17.26.26.69.43,1.04.26.52.95.61,1.47.52.52-.09.87-.17,1.56-.61.35-.17.61-.35.78-.52,0,0,.09-.09.17-.17.17-.17.26-.17.35-.35.26-.26.09-.43.26-.69.17-.17.35-.26.43-.26.17,0,.35,0,1.04.26.43.17.61.35.87.26.35-.09.43-.52.35-.78s-.35-.52-.61-.78c-.35-.35.26-1.04.69-1.13.52-.09.95.09,1.47-.17s.78-.78,1.13-1.3c.35-.43,1.04-.87,1.47-.52,0,.69-.35,1.3-.87,1.65-.26.17-.61.35-.78.61-.17.26-.09.78.26.78-.35.43-.69,1.21-.26,1.56.17.17.43.17.52.17.87,0,1.73,0,2.6-.09.17,0,.43,0,.61.17.09.09.09.17.17.26.26.26.69-.26,1.13-.17,3.03.87-1.39-.95.61.95.17.17.52.17.78.17,1.56-.09,3.12-.35,4.68-.61.26-.09.52-.09.78-.17h2.17c.26,0,.61.09.69.35.09-.09.26-.17.35-.09,0-.26.35-.35.61-.26.26.09.52.26.78.17.35-.09.87-.87.69-1.13s-.61-.26-.95-.17c-.35.09-.61.26-.95.35-.52.09-1.04-.35-1.47-.69-.09-.09-.26-.17-.26-.35-.09-.26.17-.52.43-.61.26-.09.61-.09.87-.17.26-.09.52-.35.43-.52-.09-.26-.43-.26-.61-.17-.43,0-.87.09-1.3.17-.35,0-.78-.09-1.13.17-.17.09-.35.35-.52.43-.26.26-.61.43-.95.52-.87.35-1.73.52-2.69.69h-.35c-.26-.17-.35-.69-.69-.69.26-.35.61-.69.87-1.04,0-.09-.17-.17-.35-.17s-.26.09-.35.17c-.43.17-.87.09-1.13-.26-.09,0-.17-.17-.09-.35.87-.87,1.99-1.3,3.2-1.3.09,0,.26,0,.35.09s.17.17.26.17h.26c.26-.09.43.09.69.09h.43c.69-.09,1.13,0,1.91-.09.52.09,1.04.09,1.47-.17.52.52,1.39.26,2.08.43.69.17,1.21.61,1.82.87.43.09.87.09,1.3.17.43.09.52.61.69.95.17.17.17.52.43.61.09.09.17.09.26.09.26.17.17.52,0,.69s-.52.26-.78.17c-.26,0-.17-.43-.43-.43-.09.26-.09.52,0,.78.09.26,0,.78.26.78.35,0,.61-.26.87-.43.35-.26.87-.35,1.3-.26,1.47.17,3.03-.95,4.24-.09.26.17.43.35.69.43.61.26,1.39-.17,2.08.09.52.17.95.78,1.47.61.43-.17.52-.69.95-.78.43-.09.78.52,1.13.78.43.35,1.13.17,1.39-.26.09-.17.17-.35.35-.52.26-.17.61-.17.87,0s.43.43.61.61c.35.35,1.39.78,3.64.61",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.78,210.59c.52.26,1.39.09,1.56.61-.09,0,0,.09-.09.09,2.6-.95,5.54-1.3,8.32-.87.26,0,.52.09.78,0,.17-.09.35-.17.43-.26.95-.78,1.82-1.56,2.77-2.25.35-.35.78-.69.95-1.13.17-.52-.09-1.21-.43-1.65s-.87-.78-1.3-1.13c-.26-.17-.43-.35-.52-.61-.09-.35,0-.69,0-1.04s-.43-.78-.69-.52c-.17.09-.26.43-.43.52s-.26.09-.43.09c-.69-.09-1.3-.17-1.99-.26-.43-.09-.52-.69-.35-1.04.17-.43.35-.87.09-1.21-.09-.17-.26-.26-.35-.43-.09-.26-.09-.52-.09-.69-.09-.52-.43-.87-.43-1.39,0-.78,1.13-1.04,1.73-.69.61.35.95,1.13,1.3,1.82.35.69.69,1.39,1.47,1.65.43.09.78.09,1.21.17s.87.35.87.78c0,.26-.17.52-.09.78,0,.17.09.26.17.35.35.52.78,1.04,1.39,1.3.43.17.95.26,1.39.26.52,0,1.04.09,1.65.09.35,0,.69.09.87.35.09.17.17.35.26.43.17.17.35.26.61.35,1.3.43,2.25,1.65,2.34,3.03.09.95-.26,1.99.43,2.69.17.26.52.26.87.43.17.09.52.17.61,0,.17.35.69.26,1.04.09-.09.78-.17,1.56-.35,2.34-.09.52-.17,1.04-.17,1.47,0,1.13.17,2.25-.26,3.38.17.09.35.26.35.52,0,.17-.09.43-.09.61-.26,1.21.26,2.6-.43,3.64,0-.09.09-.09.17-.09s.09.17.09.17v1.21c.52,0,.87-.52.95-.95.17-.52.26-1.04.69-1.3.43.78.52,1.73.09,2.51-.09.26-.26.43-.35.69-.09.26,0,.52.17.69.17.17.61,0,.61-.17.17-.09.17.26.35.35s.35-.09.43-.26c.69-1.3.78-2.77.61-4.24-.09-.52-.17-1.04,0-1.56.26-.87,1.21-1.39,1.56-2.25.17-.35.17-.69.35-.95.52-.95,1.99-1.13,2.43-2.17-.09.09,0,.26.09.26,0-.43.35-.69.69-.95.35-.17.69-.35.95-.69.17-.26.26-.61.43-.87s.43-.52.78-.43c.17,0,.26.09.43.09.26,0,.35-.26.43-.43.17-.17.43-.26.52-.09q0,.09.09.17c.09,1.21.26,2.43.35,3.64,0,.26.09.52.26.61s.26,0,.43.09.09.35.09.43c-.09.52-.26,1.04-.35,1.56-.09.43-.17.95.26,1.21.35.17.87-.09,1.13.17.17.09.17.35.35.43.09.09.26,0,.35-.09h.17c.09,0,.17.09.26.09,0,1.13,0,2.34.09,3.46.17-.09.26.26.35.43.17.26.61.09.78-.09.26-.26.43-.52.78-.52.17,0,.09.26.17.35.09.17.26.26.43.17.17-.09.26-.26.35-.43.52-1.04.35-2.34.09-3.46,0-.17-.09-.35-.17-.52-.09-.17-.17-.26-.26-.35-.17-.35-.09-.78-.09-1.13s-.09-.87-.43-.95c.52-.95,1.13-1.82,1.82-2.6,0,.17.17.17.35.17s.26-.09.35-.26c.26-.26.52-.43.78-.69.09-.09.26-.26.43-.26h.43c.17,0,.26-.17.43-.26.35-.35.78-.61,1.3-.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06,241.43c-.43.52-.17,1.39.35,1.82s1.3.43,1.99.43c.43,0,.78-.09,1.13-.26.61-.35.87-1.04,1.21-1.56.95-1.56,2.51-2.69,3.64-3.98.52-.61,1.47-1.65,1.13-2.51-.43-1.13-1.04-.43-1.47.09-1.04.95-1.56,1.13-3.03.95-1.21-.09-1.99-.26-2.6.95-.43.78-.87,1.65-1.21,2.43-.17.43-.09.69-.35,1.13-.09.17-.52.26-.78.52Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,231.64c.09.26.35.43.43.61.17.35.09.69.09,1.04-.17,1.3-.26,2.69-.61,3.98-.09.52-.26,1.13.17,1.47.43.35,1.13,0,1.39-.43.26-.52.35-1.04.69-1.56.17-.26.43-.52.69-.78.17-.26.35-.69.17-.95-.17-.43-.87-.61-.87-1.04,0-.35.26-.61.17-.95-.09-.17-.52-.43-.61-.78-.17-.61.26-1.3.09-1.91-.78-2.77-2.69-.26-1.82,1.3Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,228.96c.09.26.09.61.09.87,0,.69.09,1.3.35,1.91.09.17.17.35.43.43s.52-.26.52-.61-.17-.61-.26-.87-.09-.69.17-.87c.09-.09.26-.17.43-.17.43-.26.52-.87.26-1.21-.17-.26-.52-.35-.69-.52-.78-.61-.87-1.65-.52-2.51-.52,0-1.13.61-1.39,1.04-.87,1.3.17,1.47.61,2.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.99,223.76c-1.13.43-2.08,1.47-2.34,2.69-.17.61-.17,1.3-.26,1.91-.52,2.69-3.03,4.42-4.33,6.76-.09-.09.09-.17.17-.09.09.09,0,.17,0,.26-.17.52-.35,1.13-.43,1.65.78.61,1.04,1.82.61,2.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,241.17c-.52,0-1.13.17-1.56.52-.09.09-.26.17-.43.26-.17.09-.43,0-.61,0-.52,0-.78.61-.87,1.13-.26,1.21-.26,2.51-.87,3.64",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.84,
    cy: 211.72,
    r: 51.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_10-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 452.73,
    y1: 112.2,
    x2: 642.13,
    y2: 112.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.43,
    y1: 206.9,
    x2: 547.43,
    y2: 17.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.44,
    y1: 179.19,
    x2: 614.42,
    y2: 45.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.42,
    y1: 179.19,
    x2: 480.44,
    y2: 45.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.43,
    cy: 112.2,
    r: 60.95,
    transform: "translate(81 419.95) rotate(-45)",
    style: {
      fill: "url(#Unbenannter_Verlauf_42)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M560.52,64.85c20.45,5.52,35.49,24.34,35.49,46.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "654.72 148.44 725.82 148.44 750.44 186.1 679.33 186.1",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.58 186.1 654.72 148.44 679.33 186.1 679.33 283.37 629.58 283.37 629.58 186.1",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "679.33 186.1 749.84 186.1 749.84 283.37 679.33 283.25 679.33 186.1",
    style: {
      fill: "#d6e8f4",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".8px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.04,
    y: 257.51,
    width: 16.99,
    height: 25.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.68,
    y: 233.55,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.97,
    y: 233.55,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.58,
    y: 233.55,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.68,
    y: 206.34,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.97,
    y: 206.34,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.58,
    y: 206.34,
    width: 6.52,
    height: 15.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.45,
    y: 182.93,
    width: 146.31,
    height: 100.44,
    transform: "translate(1043.2 466.29) rotate(-180)",
    style: {
      fill: "#fef5bb",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.7 149.19 448.6 184.17 448.6 283.37 394.8 283.37 394.8 184.17 421.7 149.19",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.76 184.48 594.44 184.48 594.13 149.03 421.7 149.03 448.76 184.48",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.64,233.61v20.52s16.79,0,16.79,0v-20.52h0c0-4.66-3.73-8.4-8.4-8.4s-8.4,3.73-8.4,8.4",
    style: {
      fill: "#e1edd8",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.06,
    y: 253.98,
    width: 23.94,
    height: 4.04,
    transform: "translate(1126.07 512) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.19,233.61v20.52s16.79,0,16.79,0v-20.52h0c0-4.66-3.73-8.4-8.4-8.4-4.66,0-8.4,3.73-8.4,8.4",
    style: {
      fill: "#58b3e1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.77,
    y: 253.98,
    width: 23.94,
    height: 4.04,
    transform: "translate(1041.49 512) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.75,233.61v20.52s16.79,0,16.79,0v-20.52h0c0-4.66-3.73-8.4-8.4-8.4s-8.4,3.73-8.4,8.4",
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.17,
    y: 253.98,
    width: 23.94,
    height: 4.04,
    transform: "translate(956.28 512) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.14,
    y1: 150.9,
    x2: 441.45,
    y2: 169.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.45,
    y1: 259.89,
    x2: 397.45,
    y2: 186.04,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.18,
    y1: 276.99,
    x2: 452.18,
    y2: 220.71,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 484.21,
    y1: 180.28,
    x2: 589.93,
    y2: 180.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.74,
    y1: 225.37,
    x2: 520.74,
    y2: 253.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.98,
    y1: 244.19,
    x2: 512.19,
    y2: 244.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.98,
    y1: 234.7,
    x2: 512.19,
    y2: 234.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 478.14,
    y1: 225.37,
    x2: 478.14,
    y2: 253.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 486.38,
    y1: 244.19,
    x2: 469.75,
    y2: 244.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 486.38,
    y1: 234.7,
    x2: 469.75,
    y2: 234.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.03,
    y1: 225.37,
    x2: 563.03,
    y2: 253.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 571.27,
    y1: 244.19,
    x2: 554.64,
    y2: 244.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 571.27,
    y1: 234.7,
    x2: 554.64,
    y2: 234.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.2,
    y: 110.78,
    width: 53.8,
    height: 172.43,
    transform: "translate(1240.19 394) rotate(-180)",
    style: {
      fill: "#fef5bb",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "647.15 110.78 620.09 58.85 593.35 110.78 647.15 110.78",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.81,254.14l-.16,29.07h24.1s0-29.07,0-29.07h0c0-6.53-5.29-11.97-11.97-11.97-6.53,0-11.97,5.29-11.97,11.97",
    style: {
      fill: "#ab7152",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.94,
    y1: 242.01,
    x2: 619.94,
    y2: 283.21,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.39,195.05v20.52s16.79,0,16.79,0v-20.52h0c0-4.66-3.73-8.4-8.4-8.4s-8.4,3.73-8.4,8.4",
    style: {
      fill: "#58b3e1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.81,
    y: 215.42,
    width: 23.94,
    height: 4.04,
    transform: "translate(1239.57 434.89) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.39,128.51v20.52s16.79,0,16.79,0v-20.52h0c0-4.66-3.73-8.4-8.4-8.4s-8.4,3.73-8.4,8.4",
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.81,
    y: 148.88,
    width: 23.94,
    height: 4.04,
    transform: "translate(1239.57 301.8) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.77,
    y1: 104.72,
    x2: 620.72,
    y2: 65.85,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 643.88,
    y1: 278.55,
    x2: 643.88,
    y2: 147.94,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.31,
    y1: 202.05,
    x2: 596.31,
    y2: 113.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.42,
    y1: 253.83,
    x2: 629.42,
    y2: 280.72,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.78,
    y1: 186.81,
    x2: 619.78,
    y2: 215.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.02,
    y1: 205.78,
    x2: 611.39,
    y2: 205.78,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.02,
    y1: 196.3,
    x2: 611.39,
    y2: 196.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.78,
    y1: 120.11,
    x2: 619.78,
    y2: 148.72,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.02,
    y1: 139.08,
    x2: 611.39,
    y2: 139.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.02,
    y1: 129.6,
    x2: 611.39,
    y2: 129.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.78 283.31 678.08 259.78 664.15 274.53 667.41 236 653.11 273.52 648.2 251.66 643.6 283.31 669.78 283.31",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.07,
    y1: 283.41,
    x2: 1045.93,
    y2: 283.41,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.67,52.56v2.68c0,6.54,4.28,11.91,9.39,11.91h1.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.67,52.56v2.68c0,6.54-4.28,11.91-9.39,11.91h-1.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.67,81.82v-2.68c0-6.54,4.28-11.91,9.39-11.91h1.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.67,81.82v-2.68c0-6.54-4.28-11.91-9.39-11.91h-1.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38,118.93v2.01c0,4.86,3.19,8.97,7.04,8.97h1.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38,118.93v2.01c0,4.86-3.19,8.97-7.04,8.97h-1.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38,140.81v-2.01c0-4.86,3.19-8.97,7.04-8.97h1.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38,140.81v-2.01c0-4.86-3.19-8.97-7.04-8.97h-1.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.15,134.09v1.55c-.25,3.92,2.29,7.35,5.23,7.44h1.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.15,134.09v1.55c-.25,3.92-2.94,7.11-5.88,7.03h-1.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.5,151.83v-1.55c.25-3.92,2.94-7.11,5.88-7.03h1.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.5,151.83v-1.55c.25-3.92-2.29-7.35-5.23-7.44h-1.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7,98.99v1.96c0,5.07,3.35,9.23,7.11,9.23h1.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7,98.99v1.96c0,5.07-3.35,9.23-7.11,9.23h-1.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7,121.54v-1.96c0-5.07,3.35-9.23,7.11-9.23h1.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7,121.54v-1.96c0-5.07-3.35-9.23-7.11-9.23h-1.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.59,109.06c4.82,0,9.15-2.37,12.09-6.13h0c1.96-2.37,4.82-3.92,8.01-3.92s4.33.74,6.05,2.04l.16.16c1.88,1.55,4.17,2.45,6.62,2.45,5.97,0,10.87-5.31,10.87-11.85s-4.82-11.85-10.87-11.85-4.41.74-6.13,2.04h-.25c-1.8,1.63-4.09,2.53-6.54,2.53-3.51,0-6.62-1.8-8.66-4.66l.33.41c-.25-.25-.49-.49-.65-.74-2.86-3.02-6.7-4.9-11.03-4.9s-8.34,1.96-11.2,5.07l-.25.16c-1.96,2.78-5.15,4.66-8.66,4.66s-4.74-.9-6.54-2.37h-.25c-1.72-1.39-3.84-2.21-6.13-2.21-5.97,0-10.87,5.31-10.87,11.85s4.82,11.85,10.87,11.85,4.82-.9,6.62-2.45l.16-.16c1.72-1.23,3.84-2.04,6.05-2.04s6.05,1.47,8.01,3.84h0c2.86,3.76,7.19,6.13,12.09,6.13s9.64-2.61,12.58-6.78",
    style: {
      fill: "#d6e8f4",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.65,91.98c0,4.9,3.6,8.83,8.09,8.83s3.6-.65,4.98-1.8h.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.33,81.77l.25.33c-.16-.16-.33-.41-.57-.57-2.29-2.45-5.39-3.92-8.83-3.92",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.6,100.56c4.41,0,8.01-3.92,8.01-8.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.9 201.75 431.93 202.25 449 231.25 388.09 231.41 371.9 201.75",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 371.9,
    y1: 201.75,
    x2: 432.03,
    y2: 201.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.19 231 371.9 201.75 388.09 231.41 387.69 283.2 355.19 283.19 355.19 231",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.69,
    y: 231.51,
    width: 61.14,
    height: 51.69,
    style: {
      fill: "#e0edd8",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.11,
    y: 255.65,
    width: 16.79,
    height: 26.95,
    style: {
      fill: "#40abe1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.74,
    y: 248.31,
    width: 8.45,
    height: 14.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.43,
    y: 248.31,
    width: 8.45,
    height: 14.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.32,
    y: 189.98,
    width: 8.45,
    height: 11.26,
    style: {
      fill: "#e0edd8",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.83,
    y1: 230.91,
    x2: 432.54,
    y2: 201.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.66 283.2 378.03 257.05 367.64 277.4 363.57 262.25 361.49 278.7 347.03 255.75 351.25 276.58 342.96 267.61 348.76 283.2 372.66 283.2",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.33,
    y: 140.92,
    width: 6.32,
    height: 142.44,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.32,152.6l20.37,9.92-20.55,9.92c-.97,0-2.02.44-3.16.44-5.53,0-10.27-4.57-10.27-10.27s4.57-10.27,10.27-10.27,1.58,0,3.34.44",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 843.69,
    y1: 162.53,
    x2: 809.44,
    y2: 162.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.37,228.83l-13.17,6.32,13.26,6.32c.61.09,1.23.26,2.02.26,3.69,0,6.59-3.07,6.59-6.59s-3.07-6.59-6.59-6.59-1.14,0-2.11.26",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.2,
    y1: 235.07,
    x2: 802.33,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.12,120.37l.53-19.76,2.02-5.01,1.49-1.32c.7-.53,1.67,0,2.63,0l.97.35,2.2,4.48.53,4.48.7-4.83c0-.7.35-1.49.97-2.02l2.63-2.81h.7c.97.35,2.02.53,2.63,1.32l1.49,3.16,1.14,4.3v1.32l1.32-5.8,1.84-3.51,2.02-.53,2.46.53,1.67,2.63.97,4.83.35,1.67,1.49-6.32c0-.53.35-.97.53-1.32l1.32-1.67.97-.53c.97-.18,2.02,0,2.81.7l1.32,1.67,1.14,3.16.35,2.81v18.27c0,.18-.35,4.48-.35,4.65l-.97,2.81-3.16,5.18c-.7,1.14-3.16,3.51-4.3,4.13l-3.69,2.02-5.36,1.67h-6.5c0-.18-5.36-1.84-5.36-1.84l-4.3-2.81c-1.84-1.67-4.3-4.3-5.18-6.67l-1.84-6.15v-3.16h0l-.18-.09Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.21,120.9c0,11.15-9.31,20.46-20.46,20.46s-20.64-9.31-20.64-20.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.57,104.39c0-5.62-2.2-10.45-5.01-10.45s-5.01,4.65-5.01,10.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.57,104.39c0-5.62,2.2-10.45,5.01-10.45s5.01,4.65,5.01,10.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.93,104.39c0-5.62,2.2-10.45,5.01-10.45s5.01,4.65,5.01,10.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.2,104.39c0-5.62,2.2-10.45,5.01-10.45s5.01,4.65,5.01,10.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 785.47,
    y1: 104.39,
    x2: 785.12,
    y2: 120.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 826.21,
    y1: 120.9,
    x2: 826.21,
    y2: 104.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 805.93,
    y1: 104.39,
    x2: 805.93,
    y2: 83.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.08,85.6c.97,2.63,1.67,5.01,1.67,7.99",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 805.93,
    cy: 80.77,
    r: 2.63
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.46,
    cy: 84.63,
    r: 2.63
  })), /*#__PURE__*/React.createElement("path", {
    d: "M812.25,85.6c-.97,2.63-1.67,5.01-1.67,7.99",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.04,
    cy: 84.63,
    r: 2.63
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "833.64 225.57 840.33 225.57 829.37 283.37 822.68 283.37 833.64 225.57",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.3,250.01l14.96,11.43-18.4,4.65c-.84-.19-1.67,0-2.6-.19-4.55-.93-7.62-5.39-6.69-10.04.93-4.65,5.39-7.62,10.04-6.69s1.3.28,2.69.84",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 862.26,
    y1: 261.44,
    x2: 834.39,
    y2: 255.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.43,211.07l.43-2.85c1.36-10.23,10.7-17.27,20.74-15.93,10.04,1.34,17.27,10.7,15.93,20.74l-.43,2.85",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.76,
    cy: 213.48,
    r: 18.49,
    style: {
      fill: "#fff7bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.76,
    cy: 213.48,
    r: 15.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "838.39 203.14 841.79 203.66 839.34 224.15 835.67 223.59 837.61 209.51",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "837.43 209.48 834.22 213.31 831.48 210.93 838.39 203.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,89.25v2.23c0,5.76,3.81,10.5,8.08,10.5h1.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,89.25v2.23c0,5.76-3.81,10.5-8.08,10.5h-1.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,114.89v-2.23c0-5.76,3.81-10.5,8.08-10.5h1.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,114.89v-2.23c0-5.76-3.81-10.5-8.08-10.5h-1.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "309.06 227.66 315.88 227.66 315.88 224.41 319.07 224.39 320.36 223.72 321.02 222.56 321.09 218.47 322.03 218.41 322.58 217.41 321.8 216.49 321.09 215.49 321.09 213.69 320.92 212.55 320.53 211.28 320.05 210.63 319.07 212.02 317.97 212.87 316.58 213.77 314.6 214.38 313.14 214.53 312.05 214.53 311.12 215.31 310.84 215.94 310.79 216.6 310.94 217.18 311.48 217.94 312.31 218.39 313.47 218.45 313.69 219.96 313.38 222.02 312.89 223.38 311.82 225.12 310.63 226.16 309.06 227.66",
    style: {
      fill: "#fef5b9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.05 247.56 336.12 276.19 337.38 276.68 337.86 276.19 338.78 276.18 339.33 275.65 339.65 275.23 340.46 275.48 341.16 275.47 341.5 274.88 341.5 273.41 342.49 273.14 342.66 272.73 342.66 272.1 341.24 267.31 340.46 266.76 339.16 266.68 333.62 247.47 328.05 247.56",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.35 247.49 296.91 247.58 289.82 273.17 288.72 273.51 288 272.73 289.05 268.74 278.79 275.3 278.04 274.48 278.04 273.79 277.09 273.79 276.82 272.73 280.36 270.15 276.97 270.21 275.95 269.4 276.7 268.4 278.04 268.39 283.07 268.32 285.62 266.65 291.35 247.49",
    style: {
      fill: "#fff6bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,207.78c-.51-.3-2.26-1.22-4.57-.92-1.69.21-2.88.97-3.45,1.4-.44.33-1.23,1-1.88,2.06-.18.29-.56.96-.82,1.92-.34,1.23-.08,1.52-.32,2.99-.1.59-.26,1.62-.85,2.8-.57,1.16-1.28,1.94-1.67,2.32-.43.42-1.29,1.26-2.64,1.77-1.48.56-1.8.06-3.95.69-1.44.42-2.02.85-2.38,1.22-.18.18-.66.69-.96,1.52-.16.43-.36,1.2-.21,2.14.18,1.13.76,1.82,1.18,2.32.39.47.75.9,1.09.82.37-.08.26-.66.8-1.42.66-.93,1.65-1.27,1.91-1.37.26-.08.5-.14.94-.2,1.29-.17,2.32-.15,2.87-.14,0,0,2.01.03,4.43,0,.67,0,1.22-.02,1.56-.04l1.59-.87,1.34-1.3,1.46-2.09.67-3.08-.07-1.86-1.16-.06-1.38-1.21-.08-1.24.28-.62,1.38-.9,1.06-.02h1.05s1.98-.61,1.98-.61l1.39-.9,1.39-1.21.7-1.05-.87-1.43-1.23-1.08-.54-.34h0Z",
    style: {
      fill: "#944722"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.88 224.41 318.55 224.41 318.55 225.82 318.04 227.41 316.25 227.62 315.88 227.66 315.88 224.41",
    style: {
      fill: "#944722"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.35 247.49 300.36 247.49 300.46 263.8 324.53 263.8 324.61 247.47 333.62 247.47 329.12 231.35 328.35 229.82 326.37 228.17 323.76 227.68 302.51 227.68 298.7 228.02 296.79 229.38 295.81 231.53 291.35 247.49",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.26 308.06 297.5 308.06 312.54 266.87 328.65 311.35 338.93 305.64 323.98 263.8 301.37 263.79 285.26 308.06",
    style: {
      fill: "url(#Unbenannter_Verlauf_43)",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.51 310.34 296.5 310.42 297.5 308.06 291.24 308.1 290.51 310.34",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.67 308.56 334.7 310.77 339.82 307.82 338.93 305.64 333.67 308.56",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.51 310.34 296.5 310.42 306.21 313.22 307.17 314.17 307.17 315.35 306.69 316.32 305.81 316.78 288.06 316.84 290.51 310.34",
    style: {
      fill: "#f6b5b3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.7 310.77 339.82 307.82 348.91 305.54 350.31 305.6 351.18 306.34 351.39 307.07 351.19 308.2 336.88 317.05 334.7 310.77",
    style: {
      fill: "#f6b5b3"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "324.53 231.97 324.53 263.8 300.46 263.8 300.46 231.97",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.57,
    y1: 227.68,
    x2: 324.53,
    y2: 227.68,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.51,227.68c-.46.03-1.83.19-3.08,1.27-1.31,1.14-1.64,2.57-1.73,3.01-3.16,10.93-6.94,23.81-10.09,34.74",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.91 247.58 291.37 267.3 289.84 272.76",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.35,
    y1: 247.49,
    x2: 300.36,
    y2: 247.49,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.25,
    y1: 249.22,
    x2: 294.8,
    y2: 249.22,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.03,
    y1: 250.19,
    x2: 294.58,
    y2: 250.19,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.82,272.81c-.11.5-.6.8-1.09.7s-.8-.6-.7-1.09",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.06,
    y1: 272.32,
    x2: 289.16,
    y2: 268.39,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "277.09 272.31 285.62 266.7 289.05 266.7",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "283.31 270.42 282.61 270.88 278.3 273.71",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "288.83 269 283.87 272.25 279.58 275.09",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.37,
    y1: 239.26,
    x2: 298.03,
    y2: 232.87,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,227.68c.46.03,1.83.19,3.08,1.27,1.31,1.14,1.64,2.57,1.73,3.01,3.16,10.93,6.94,23.81,10.09,34.74",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "328.05 247.56 333.6 267.28 335.12 272.73",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.62,
    y1: 247.47,
    x2: 324.61,
    y2: 247.47,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.72,
    y1: 249.2,
    x2: 330.17,
    y2: 249.2,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.94,
    y1: 250.17,
    x2: 330.39,
    y2: 250.17,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.6,
    y1: 239.22,
    x2: 326.94,
    y2: 232.85,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.59,267.98c-.28-.97-1.28-1.54-2.26-1.26",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.92,272.34c-.13-.49-.64-.78-1.12-.65s-.78.64-.65,1.12l.91,3.21c.15.49.66.76,1.14.61s.76-.66.61-1.14l-.9-3.17h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,271.83c-.13-.49-.64-.78-1.12-.65s-.78.64-.65,1.12l.91,3.21c.15.49.66.76,1.14.61s.76-.66.61-1.14l-.9-3.17h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.59,271.31c-.13-.49-.64-.78-1.12-.65s-.78.64-.65,1.12l.91,3.21c.15.49.66.76,1.14.61s.76-.66.61-1.14l-.9-3.17h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,269.65l.91,3.21c.15.49.66.76,1.14.61s.76-.66.61-1.14l-1.23-4.33",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.13,269.62c-.97.28-1.98-.29-2.26-1.26",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.97,227.66h6.91s0-3.25,0-3.25h2.88c1.22,0,2.19-.98,2.19-2.19v-3.75h.85",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.09,214.12c0-4.04-3.28-7.33-7.33-7.33s-7.33,3.28-7.33,7.33",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,218.47c.5,0,.91-.41.91-.91,0-.25-.11-.48-.26-.65",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.25,216.86c-1.09-.72-1.18-1.77-1.15-2.74",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.03,222.73c4.63.03,8.4-3.83,8.43-8.63",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.99,230.81c-1.38-.71-2.32-2.14-2.32-3.8,0-2.36,1.92-4.27,4.27-4.27",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.49,227.64c.13-.05.25-.11.38-.17,3.26-1.55,5.28-5.18,4.73-9.06",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.54,218.3c-.23.1-.49.15-.74.15-1.11,0-2.01-.91-2.01-2.03s.9-2.03,2.01-2.03c.23,0,.46.04.67.12.02,0,.04.01.06.02",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.97,227.62c.36-.96.57-2.01.58-3.1",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.05,210.56c-1.22,2.36-3.67,3.97-6.51,3.97",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,210.56c-.17,1.48-.54,2.17-1.62,3.36",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,211.11c-.85.98-1.94,1.74-3.19,2.17",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.07,219.48c.54.54,1.13.97,1.78,1.3",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.9,
    cy: 215.38,
    r: 0.49,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "301.37 263.79 300.39 266.47 285.26 308.06 297.5 308.06",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "312.54 266.87 296.88 310.08 296.1 312.15",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "287.38 307.96 302.52 266.35 303.44 263.82",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.69,
    y1: 304.44,
    x2: 298.94,
    y2: 304.44,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.24,308.1l-3.18,8.74h17.29s.08,0,.08,0c1.08-.04,1.91-.92,1.91-1.91,0-.86-.65-1.65-1.55-1.85-3-.88-5.99-1.77-8.98-2.65-2.1-.02-4.2-.05-6.3-.07",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.66,
    y1: 315.64,
    x2: 307.02,
    y2: 315.64,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.33,
    y1: 310.87,
    x2: 297.54,
    y2: 312.96,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.82,
    y1: 311.31,
    x2: 299.05,
    y2: 313.39,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.36,
    y1: 311.77,
    x2: 300.58,
    y2: 313.86,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.82,
    y1: 305.21,
    x2: 339.86,
    y2: 308.08,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "330.46 310.15 315.7 269.57 314.48 266.22",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.82,
    y1: 307.82,
    x2: 340.21,
    y2: 310,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.88,317.05l13.56-8.05.06-.05c.91-.58,1.18-1.77.68-2.62-.44-.74-1.4-1.1-2.28-.8-3.03.76-6.06,1.52-9.08,2.29-1.7.98-3.42,1.96-5.12,2.94",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.45,
    y1: 315.89,
    x2: 351.39,
    y2: 307.07,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.36,
    y1: 307.44,
    x2: 341.75,
    y2: 309.63,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.87,
    y1: 307.05,
    x2: 343.26,
    y2: 309.24,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.43,
    y1: 306.68,
    x2: 344.82,
    y2: 308.86,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.79,
    y1: 308.56,
    x2: 336.88,
    y2: 317.05,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.93,
    y1: 305.64,
    x2: 328.65,
    y2: 311.35,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.68,
    y1: 302.2,
    x2: 327.63,
    y2: 307.97,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.55,
    y1: 266.87,
    x2: 316.39,
    y2: 265.43,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.53,224.92c1.27-1.32,2.09-3.12,2.19-5.14",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.37,220.77c3.24,1.24,6.8.26,9.11-2.19.76-.82,1.4-1.8,1.82-2.92",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "283.02 268.32 281.98 268.33 276.82 268.38",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,273.75c-.39.32-.96.25-1.28-.14s-.25-.96.14-1.28",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,275.05c-.39.32-.96.25-1.28-.14s-.25-.96.14-1.28",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.02,270.21c-.5.05-.95-.31-1.01-.8s.31-.95.8-1.01",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.31,
    y1: 270.15,
    x2: 277.09,
    y2: 270.21,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 323.13,
    y1: 265.39,
    x2: 335.33,
    y2: 298.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.87,
    y1: 272.67,
    x2: 296.83,
    y2: 305.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.9,
    y1: 251.98,
    x2: 337.46,
    y2: 264.39,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.13,
    y1: 237.76,
    x2: 323.13,
    y2: 261.49,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,264.71c.03-.1,3.73-12.82,3.73-12.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.15,228.41c-.25-.48-.4-1.02-.4-1.59,0-1.85,1.5-3.36,3.36-3.36",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.87,211.94c.77-2.65,3.26-4.39,5.91-4.02",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_23"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "865.28 228.85 885.61 208.62 905.46 228.06 904.21 229.51 884.97 248.39 865.28 228.85",
    style: {
      fill: "#d5e8d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "926 207.97 905.39 228.13 885.76 208.49 906.45 188.34 926 207.97",
    style: {
      fill: "url(#Unbenannter_Verlauf_75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 912.32,
    y: 186.51,
    width: 2.5,
    height: 27.97,
    transform: "translate(125.54 704.3) rotate(-44.97)",
    style: {
      fill: "#d5e8d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "865.49 222.34 865.63 228.84 906.32 188.28 925.95 207.94 925.98 201.45 906.47 181.67 865.49 222.34",
    style: {
      fill: "url(#Unbenannter_Verlauf_74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "868.22 223.61 865.69 217.84 881.46 210.52 868.22 223.61",
    style: {
      fill: "#d5e8d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "913.84 191.11 919.75 189.84 920.95 197.94 913.84 191.11",
    style: {
      fill: "#d5e8d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.63,230.53l6.78-.08.26-2.71-.88-.83-1.72-1.36-1.25-1.92-.57-2.13.98.11.83-.16.73-.83.36-.83-.26-1.04-.88-1.04-1.14-.05-.78.05-.88-.78-.21-1.25.52-.88.83-.57-.11-1.09-.73-.62-1.04.26-.73.57-1.25.31-.88-.05-1.04-.36-1.04,1.61-.57,1.92-.36,1.77c-.49.76-.97,1.52-1.46,2.3l.05.77.58.32.87.04.05,3.43.11.83.88,1.14.62.31,3.06.57.23,2.28h.03Z",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "910.3 233.58 905.72 237.6 899.26 234.54 901.47 232.28 902.89 232.68 904.3 232.28 905.23 232 904.87 230.98 903.12 228.49 903 227.42 903.45 226.9 904.42 227.24 909.91 233.02",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "909.22 222.63 915.06 228.58 910.42 233.1 905.66 228.3 908.6 225.47 908.66 224.95 908.09 224.22 907.99 223.14 908.26 222.63 909.22 222.63",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "931.6 213.24 932.88 213.7 934.41 213.54 935.44 213.07 936.37 212.72 937.26 213.13 937.34 213.75 937.16 214.34 936.34 215.13 936.07 215.88 936.21 216.49 936.56 217.37 937.37 217.84 938.62 217.71 939.92 218.56 939.98 219.15 940.01 220.3 939.64 221.04 939.07 221.45 938.02 221.76 937.26 221.5 937.56 223.16 938.55 224.97 939.87 226.32 941.55 227.44 944.35 218.7 944.17 215.88 942.95 213.6 941.45 212.1 939.15 211.13 936.68 210.83 934.29 211.39 932.88 212.04 931.6 213.24",
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "914.34 308.62 924.87 313.24 937.79 280.46 950.63 310.43 962.77 310.17 948.37 264.89 927.6 264.89 914.34 308.62",
    style: {
      fill: "#fef5bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "919.79 310.97 917.85 315.49 905.68 309.92 906.48 307.1 914.4 308.51 919.79 310.97",
    style: {
      fill: "#58b3e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "942.87 315.29 957.37 315.17 956.07 310.41 950.63 310.43 942.99 312.2 942.87 315.29",
    style: {
      fill: "#58b3e1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.94,230.73c-.3-.64-.36-1.37-.21-2.04.12-.54.51-.97.43-1.52-.1-.79-1-1.61-1.45-2.24-.39-.55-.97-1.37-.7-1.97.13-.28.46-.52.76-.52.29,0,.51.21.59.3.5.5,2.71,2.77,5.72,5.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "910.43 233.11 915.01 228.55 927.49 241.07 929.38 243.22 923.06 247.58 911.31 241.24 910.25 234.7",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_33"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "905.77 228.32 922.61 245.98 926.22 242.56 926.49 241.36 926.4 239.98 911.05 224.53 909.01 222.3 908.08 222.67 907.9 223.79 908.74 224.98 905.77 228.32",
    style: {
      fill: "url(#Unbenannter_Verlauf_73)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.94,230.73c-.3-.64-.36-1.37-.21-2.04.12-.54.51-.97.43-1.52-.1-.79-1-1.61-1.45-2.24-.39-.55-.97-1.37-.7-1.97.13-.28.46-.52.76-.52.29,0,.51.21.59.3.5.5,2.71,2.77,5.72,5.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.37,250.48l.12.13c1.46,1.47,3.89,1.44,5.4-.07l.17-.17",
    style: {
      fill: "#fff6bb",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "910.43 233.11 915.01 228.55 927.49 241.07 929.38 243.22 923.06 247.58 911.31 241.24 910.25 234.7",
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.89,217.24c-.04.42-.29,1.36-.85,2.34-.15.25-.35.57-.54,1.08-.16.44-.25.7-.15.92.16.35.73.49,1.39.41v3.23c-.03,1.18.79,2.45,2.01,2.45l2.71.48.02,2.27,7.08.1.1-3.07c.89-3.24,2.63-8.35,2.65-9.17.02-.82.23-3.17-1.82-5.32-1.82-1.92-4.35-2.06-5.01-2.08h-.11c-2.54-.01-5.03,1.16-6.35,3.03-.2.29-.58.84-.95,2.12-.18.61-.18,1.09-.19,1.23h.01Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.35,221.52c.23.1.48.14.74.14,1.11,0,2.04-.88,2.08-1.96s-.84-1.97-1.95-1.97c-.23,0-.46.04-.67.11-.02,0-.04.01-.06.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.92,222.89c-.66.37-1.36.64-2.05.79",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 932.08,
    cy: 218.4,
    rx: 0.52,
    ry: 0.5,
    transform: "translate(-17.63 338.93) rotate(-20.42)",
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.7,227.34c-2.21-.89-4.06-2.89-4.39-5.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.67,232.33c.93.35,2,.42,2.96.1.29-.1.6-.29.65-.58.02-.16-.04-.31-.12-.43-.39-.75-1.2-1.75-1.33-1.93-.39-.55-.97-1.37-.7-1.97.13-.28.46-.52.76-.52.29,0,.51.21.59.3.5.5,2.71,2.77,5.72,5.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.81,233.92c-.74.17-1.43-.04-2.06-.42",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 905.79,
    y1: 237.46,
    x2: 899.54,
    y2: 234.35,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 925.06,
    y1: 312.91,
    x2: 937.77,
    y2: 280.58,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 914.26,
    y1: 308.65,
    x2: 914.01,
    y2: 310.78,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.38,317l-13.66-6.26h.03c-.93-.48-.91-2.14-.38-2.95.74-1.13,1.25-1.06,2.54-1.02,3.05.44,5.32,1.42,8.36,1.86,1.75.78,2.98,1.32,4.73,2.11",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 912.72,
    y1: 308.43,
    x2: 912.46,
    y2: 310.57,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 911.2,
    y1: 308.19,
    x2: 910.95,
    y2: 310.33,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "919.69 311.19 919.53 311.53 917.42 317.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 914.26,
    y1: 308.69,
    x2: 924.81,
    y2: 313.2,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 916.04,
    y1: 303.04,
    x2: 926.83,
    y2: 307.84,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "927.45 264.86 926.65 267.52 914.24 308.89",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 917.72,
    y1: 315.53,
    x2: 903.29,
    y2: 308.96,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.87,264.88l-19.7-.02h.08c-1.64.01-2.96-1.31-2.96-2.95l1.19-19.67c-.18-5.52,3.12-10.19,7.84-11.74h7.34c4.7,1.56,8,6.23,7.84,11.74l1.19,19.67c0,1.64-1.33,2.96-2.96,2.96",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.88,213.36c.65.32,1.34.4,1.63.38.76-.05,1.44-.43,1.63-.55.43-.25.54-.42.91-.5.14-.02.65-.12,1.02.2.32.28.4.75.31,1.12-.16.59-.72.53-1.09,1.2-.04.07-.42.78-.13,1.56.31.79,1.1,1.05,1.22,1.09",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 909.74,
    y1: 307.9,
    x2: 909.49,
    y2: 310.04,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 906.61,
    y1: 306.98,
    x2: 905.5,
    y2: 309.88,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 962.8,
    y1: 310.25,
    x2: 948.28,
    y2: 264.97,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 962.77,
    y1: 310.31,
    x2: 950.66,
    y2: 310.51,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948.39,
    y1: 304.62,
    x2: 960.79,
    y2: 304.59,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 932.51,
    y1: 268.13,
    x2: 950.52,
    y2: 310.22,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 950.36,
    y1: 310.5,
    x2: 951.03,
    y2: 312.56,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.05,316.82l-16.4-.02.02-.02c-1.05-.04-1.72-1.57-1.57-2.53.2-1.33.7-1.47,1.88-1.98,2.95-.86,5.42-.92,8.38-1.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948.87,
    y1: 310.95,
    x2: 949.52,
    y2: 313,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 947.38,
    y1: 311.37,
    x2: 948.05,
    y2: 313.41,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 957.31,
    y1: 315.39,
    x2: 940.33,
    y2: 315.42,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 945.93,
    y1: 311.71,
    x2: 946.59,
    y2: 313.75,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 942.7,
    y1: 312.16,
    x2: 942.89,
    y2: 315.27,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 958.05,
    y1: 316.83,
    x2: 956.05,
    y2: 310.62,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 924.9,
    y1: 306.79,
    x2: 936.32,
    y2: 277.25,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 958.53,
    y1: 304.52,
    x2: 945.89,
    y2: 265.09,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 882.19,
    y1: 240.26,
    x2: 886.17,
    y2: 244.26,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 882.7,
    y1: 243.08,
    x2: 882.19,
    y2: 240.27,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.03,240.7l-2.38-2.39c-.44-.44-1.18-.43-1.63.02s-.48,1.19-.03,1.63v.02l2.47,2.47c.44.44,1.18.43,1.63-.02s.48-1.19.03-1.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.73,238.01l-2.38-2.39c-.44-.44-1.18-.43-1.63.02s-.48,1.19-.03,1.63v.02l2.47,2.47c.44.44,1.18.43,1.63-.02s.48-1.19.03-1.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 897.55,
    y1: 200.56,
    x2: 901.52,
    y2: 204.56,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 898.04,
    y1: 203.37,
    x2: 897.55,
    y2: 200.57,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.38,200.99l-2.38-2.39c-.44-.44-1.18-.43-1.63.02s-.48,1.19-.03,1.63v.02l2.47,2.47c.44.44,1.18.43,1.63-.02s.48-1.19.03-1.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.08,198.3l-2.38-2.39c-.44-.44-1.18-.43-1.63.02s-.48,1.19-.03,1.63v.02l2.47,2.47c.44.44,1.18.43,1.63-.02s.48-1.19.03-1.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 905.55,
    y1: 228.34,
    x2: 908.8,
    y2: 225.11,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "910.33 223.59 926.07 207.95 906.49 188.24 885.95 208.66 865.48 229.03 885.05 248.72 902.7 231.18 904.05 229.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 905.42,
    y1: 228.16,
    x2: 886.19,
    y2: 208.79,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 912.46,
    y: 186.83,
    width: 2.45,
    height: 27.77,
    transform: "translate(124.19 702.52) rotate(-44.83)",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.53,
    y: 225.02,
    width: 9.13,
    height: 5.6,
    transform: "translate(93.57 682.49) rotate(-44.83)",
    style: {
      fill: "#010102",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "865.51 226.84 885.99 206.48 906.52 186.05 926.1 205.76",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "878.27 211.98 886.03 204.26 906.57 183.85 926.14 203.54",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 865.54,
    y1: 224.63,
    x2: 867.88,
    y2: 222.31,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "920.68 195.8 926.19 201.34 926.07 207.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "874.06 213.99 886.08 202.06 906.61 181.65 915.25 190.34",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "865.48 229.03 865.59 222.43 867.16 220.87",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "868.48 223.5 867.83 222.16 867.2 220.84 865.84 218.02 873.49 214.3 878 212.12 882.48 209.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "913.77 190.8 919.89 189.8 920.87 198.15",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.81,245.84l-12.48-12.52-6.27,6.26,15.63,15.67.12.13c1.46,1.47,3.89,1.44,5.4-.07l.17-.17,14.97-14.93c1.66-1.65,1.7-4.3.1-5.91s-4.25-1.57-5.91.08l-13.22,13.18",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 910.54,
    y1: 235.36,
    x2: 920.53,
    y2: 245.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 924.47,
    y1: 245.92,
    x2: 933.91,
    y2: 236.55,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.6,260.92c-.13-.19-1.14-19.12-1.14-19.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 916.32,
    y1: 306.34,
    x2: 926.95,
    y2: 271.09,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 867.3,
    y1: 218.51,
    x2: 868.8,
    y2: 221.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 918.99,
    y1: 191.01,
    x2: 919.56,
    y2: 195.63,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 906.67,
    y1: 189.78,
    x2: 922.06,
    y2: 205.12,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 884.99,
    y1: 247.21,
    x2: 873.32,
    y2: 235.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.89,251.94l1.63-.93,1.03-.79.6-1.22.51-2.1.75,2.19.98,1.49,1.16.79,1.26.47c.1.19-1.45,1.16-1.45,1.16l-1.12.98-.84,1.36-.47,2-.93-2.48-1.16-1.54-1.07-.6-.89-.79h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.73,244.46v1.41c.02,3.46,2.36,6.23,5.18,6.2h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.73,244.46v1.41c.01.98-.17,1.92-.5,2.74-.25.62-.58,1.19-.98,1.67-.56.68-1.24,1.21-2.01,1.51-.51.2-1.05.32-1.61.32h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.81,259.75v-1.41c-.02-3.46,2.28-6.25,5.1-6.26h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.81,259.75v-1.41c-.02-3.46-2.36-6.23-5.18-6.2h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.29,201.42l1.63-.93,1.03-.79.6-1.22.51-2.1.75,2.19.98,1.49,1.16.79,1.26.47c.1.19-1.45,1.16-1.45,1.16l-1.12.98-.84,1.36-.47,2-.93-2.48-1.16-1.54-1.07-.6-.89-.79h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.12,193.95v1.41c.02,3.46,2.36,6.23,5.18,6.2h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.12,193.95v1.41c.01.98-.17,1.92-.5,2.74-.25.62-.58,1.19-.98,1.67-.56.68-1.24,1.21-2.01,1.51-.51.2-1.05.32-1.61.32h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.2,209.24v-1.41c-.02-3.46,2.28-6.25,5.1-6.26h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.2,209.24v-1.41c-.02-3.46-2.36-6.23-5.18-6.2h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.89,251.94l1.63-.93,1.03-.79.6-1.22.51-2.1.75,2.19.98,1.49,1.16.79,1.26.47c.1.19-1.45,1.16-1.45,1.16l-1.12.98-.84,1.36-.47,2-.93-2.48-1.16-1.54-1.07-.6-.89-.79h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.73,244.46v1.41c.02,3.46,2.36,6.23,5.18,6.2h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.73,244.46v1.41c.01.98-.17,1.92-.5,2.74-.25.62-.58,1.19-.98,1.67-.56.68-1.24,1.21-2.01,1.51-.51.2-1.05.32-1.61.32h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.81,259.75v-1.41c-.02-3.46,2.28-6.25,5.1-6.26h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.81,259.75v-1.41c-.02-3.46-2.36-6.23-5.18-6.2h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.68,
    y: 240.13,
    width: 10.8,
    height: 1.75,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.66,
    y: 259.13,
    width: 10.83,
    height: 1.75,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.66,
    y: 266.57,
    width: 10.83,
    height: 1.75,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.06,
    y: 226.39,
    width: 4.69,
    height: 1.75,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.05,
    y: 233.83,
    width: 4.71,
    height: 1.75,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.05,
    cy: 267.44,
    r: 2.33,
    style: {
      fill: "#fef5ba",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.58 208.78 182.4 207.69 191.15 207.57 199.53 207.69 201.36 208.72 202.15 210.26 202.15 211.73 201.42 213.45 200.07 214.36 198.72 214.79 196.21 216.2 194.12 218.47 193.02 221.35 192.71 229.81 192.83 248.51 192.71 268.31 193.63 271.01 195.84 273.09 197.98 273.27 200.44 272.91 201.97 271.86 203.01 270.58 203.44 268.55 203.62 209.77 203.44 182.18 203.69 166.18 203.87 164.65 204.6 163.12 205.71 161.83 207.55 160.97 209.57 160.73 211.53 161.4 212.7 162.14 213.8 163.49 214.29 164.83 214.47 166.24 214.66 179.3 214.54 241.89 215.7 243.85 214.41 243.91 211.72 244.03 210.49 244.4 211.72 242.13 211.96 199.59 211.84 166.12 210.98 164.59 209.88 164.16 208.77 164.16 207.85 164.65 207.3 165.63 207.3 166.43 207.18 227.97 207.12 253.04 207.18 266.41 207.24 268.86 206.75 271.01 205.71 273.27 204.42 274.68 202.95 275.79 200.8 276.83 198.35 277.26 195.78 276.83 193.57 275.79 191.18 274.01 189.95 271.86 189.28 268.98 189.28 267.33 189.22 223.68 188.97 221.41 188.36 219.33 186.52 216.82 184.19 215.16 182.66 214.79 180.94 213.87 179.78 211.85 180.02 210.01 180.58 208.78",
    style: {
      fill: "url(#Unbenannter_Verlauf_65)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.17,
    y: 252.98,
    width: 3.33,
    height: 11.12,
    style: {
      fill: "url(#Unbenannter_Verlauf_64)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.25,
    y: 237.26,
    width: 3.33,
    height: 11.12,
    style: {
      fill: "url(#Unbenannter_Verlauf_64-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 208.42 198.72 208.42 200.06 209.05 200.85 210.54 200.85 211.88 200.22 212.98 199.04 213.76 191.65 213.69 183.08 213.61 181.43 212.98 180.96 211.72 180.88 210.38 181.74 209.13 182.92 208.42",
    style: {
      fill: "url(#Unbenannter_Verlauf_63)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "183.65 214.75 197.88 214.69 198.48 214.69 196.02 216.2",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "197.99 214.7 194.39 217.94 193.35 219.69 192.77 222.18 192.77 233.09 189.05 233.27 189.05 225.66 189.05 222.3 188.3 219.63 186.79 217.31 184.76 215.62 183.65 214.75",
    style: {
      fill: "url(#Unbenannter_Verlauf_62)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.73 283.31 184.02 283.66 181.13 255.17 181.24 253.68 182.48 246.36 182.3 243.9 181.46 242.22 175.82 234 173.19 232.02 170.61 231.06 167.61 231.06 165.03 231.84 163.17 232.86 161.61 234.48 160.29 236.4 159.39 238.92 159.15 240.9 161.43 255.65 158.91 256.85 156.33 259.19 154.41 262.01 153.21 265.19 151.73 283.31",
    style: {
      fill: "url(#Unbenannter_Verlauf_60)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.21 305.64 184.02 283.66 176.76 283.66 175.67 285.16 175.47 287.54 175.67 289.73 176.07 291.32 181.04 305.54 186.21 305.64",
    style: {
      fill: "#f9cabf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.11 305.7 154.42 305.7 162.48 283.76 155.39 283.73 153.45 285.42 151.52 289.4 150.19 297.97 149.11 305.7",
    style: {
      fill: "#f9cabf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.62 248.53 186.77 248.46 187.26 247.56 188.16 247.07 189.07 247.07 189.13 248.4 195.73 248.59 196.52 248.77 196.27 249.74 196.4 250.22 196.64 250.7 196.27 251.37 196.7 251.98 196.4 252.76 195.91 253.07 186.71 253.13 168.73 254.82 167.22 254.76 165.77 254.03 164.86 252.94 164.49 251.37 164.62 248.53",
    style: {
      fill: "#f9cabf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.14 218.78 173.79 218.78 174.02 219.79 174.07 221.4 174.07 221.82 175.13 221.82 175.77 222.23 175.82 222.83 175.72 223.33 174.9 223.65 173.93 223.7 173.93 226.14 173.61 227.47 172.87 228.62 171.77 229.81 170.85 230.41 169.7 230.92 168.09 230.96 168 224.99 167.08 224.67 166.35 223.79 165.98 222.97 166.16 221.68 167.08 220.9 168.05 220.71 168.14 218.78",
    style: {
      fill: "#f9cabf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.79 218.78 172.91 216.9 171.19 214.97 169.12 214.15 166.57 214.15 164.37 214.84 162.64 216.35 161.61 218.08 161.27 220.14 161.2 231.03 168.09 230.96 168 224.99 166.36 224.21 165.98 222.97 166.16 221.68 167.08 220.9 168.05 220.71 168.14 218.78 173.79 218.78",
    style: {
      fill: "#eb5b5e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.63 313.51 191.61 313.71 192.72 312.8 193.1 311.75 192.87 310.73 191.62 309.82 186.7 308.58 187.21 308.07 187.72 307.16 187.38 306.31 186.76 305.69 186.21 305.64 181.04 305.54 180.02 306.26 179.8 307.27 180.19 308.12 181.1 308.46 181.21 313.78 182.51 313.73 182.57 312.08 184.63 313.51",
    style: {
      fill: "url(#Unbenannter_Verlauf_58)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.15 305.76 154.63 305.76 155.67 306.28 155.72 307.28 155.72 307.76 154.96 308.52 159.44 309.85 160.72 310.28 161.1 311.23 160.96 312.33 160.25 313.14 159.25 313.57 152.2 313.71 150.62 312.04 149.72 313.76 148.24 313.71 148.91 308.47 148.1 307.76 147.96 306.95 148.19 306.37 149.15 305.76",
    style: {
      fill: "url(#Unbenannter_Verlauf_58-2)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.09,248.45c.11-.7.22-1.4.33-2.1v-.06c.08-.33.11-.66.11-1.01,0-.86-.22-1.66-.6-2.36l-.03-.05-4.94-7.21-.03-.05c-1.73-2.81-4.82-4.67-8.22-4.63-5.38.06-9.83,4.84-9.41,10.44.73,4.68,1.45,9.36,2.18,14.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,255.59c-4.58,1.77-7.9,6.05-8.3,11.14v-.12l-1.62,16.94c.12,0,32.35-.01,32.35-.01l-2.86-28.26v-.07c.07-.47.14-.95.22-1.42",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,250.74c0,.17-.03,2.21,1.66,3.41,1.4.99,2.93.68,3.18.63,5.93-.59,11.85-1.17,17.78-1.76",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.79,
    y1: 248.53,
    x2: 164.49,
    y2: 248.53,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.36,248.35v-11.04c0-2.2-1.78-3.99-3.99-3.99s-3.99,1.78-3.99,3.99c0,0-.02,13.26,0,13.45",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,248.54c0-.7.47-1.28,1.12-1.44h1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,253.02h-1.25l8.87-.04c.41,0,.74-.35.73-.76s-.35-.74-.76-.73l-4.14.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,251.49c.41,0,.74-.35.73-.76s-.35-.74-.76-.73h-2.66",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.73,250.02l4.12-.02c.41,0,.74-.35.73-.76s-.35-.74-.76-.73l-7.36.04",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.99,221.89h1.12c.49,0,.89.39.89.89s-.4.89-.89.89h-1.05",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.28,230.97c3.16,0,5.71-2.57,5.71-5.72v-1.57",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,224.49c.71.68,1.62,1.02,2.53,1.01",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.69,
    cy: 220.87,
    r: 0.54,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,224.93c-1.17,0-2.12-.94-2.12-2.11s.94-2.12,2.11-2.12v-1.94h5.62",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "161.22 220.34 161.22 230.96 168.9 230.96",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.09,
    y1: 230.7,
    x2: 168.09,
    y2: 224.95,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.22,220.35c0-3.52,2.86-6.38,6.38-6.38s6.38,2.86,6.38,6.38v1.51",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,277.47l2.86,28.26h-5.12l-4.69-13.57s-2.29-6.74.5-8.56",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5,283.72l-8.18,22h-5.12l1.73-13.57s.9-6.74,4.54-8.56",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.41,305.74h5.19c.75,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37h-.64",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,305.74c-.75,0-1.37.61-1.37,1.37s.61,1.37,1.37,1.37h.83",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,313.67h-7.04l-1.53-1.64-.85,1.73h-1.42l.64-5.23",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,313.68c1.16-.05,2.05-1,2.03-2.03,0-.87-.66-1.67-1.59-1.9-1.72-.42-3.19-.85-4.91-1.27",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,305.74h5.19c.75,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37h-.64",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,305.74c-.75,0-1.37.61-1.37,1.37s.61,1.37,1.37,1.37h.83",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.46,313.67h-6.79l-2.08-1.64v1.73h-1.42v-5.23",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,313.68c1.16-.05,2.05-1,2.03-2.03-.01-.87-.66-1.67-1.59-1.9-1.72-.42-3.45-.85-5.17-1.27",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.29,207.63c-1.95,0-3.53,1.58-3.53,3.53s1.58,3.53,3.53,3.53h15.19",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.55,214.69c1.95,0,3.53-1.58,3.53-3.53s-1.58-3.53-3.53-3.53h-15.24",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.41,208.54c-1.44,0-2.62,1.17-2.62,2.62s1.17,2.62,2.62,2.62h14.96",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,213.77c1.44,0,2.62-1.17,2.62-2.62s-1.17-2.62-2.62-2.62h-15.07",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1,
    y1: 248.4,
    x2: 189.1,
    y2: 223.12,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "192.66 253.1 192.66 267.81 189.1 267.81 189.1 253.03",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.66,
    y1: 223.19,
    x2: 192.66,
    y2: 248.36,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,214.6c3.87.94,6.74,4.42,6.74,8.58",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.4,214.6c-3.87.94-6.74,4.42-6.74,8.58",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.49,
    y: 166.27,
    width: 3.55,
    height: 102.07,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,268.26c0,4.95-4.05,8.8-9,8.8s-8.96-4.25-8.96-9.2",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,267.95c0,3-2.43,5.43-5.43,5.43s-5.43-2.43-5.43-5.43",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.73,
    y: 166.23,
    width: 2.75,
    height: 75.72,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.47,166.21c0-3.03-2.46-5.49-5.49-5.49s-5.49,2.46-5.49,5.49",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.73,166.3c0-1.29-1.05-2.34-2.34-2.34s-2.34,1.05-2.34,2.34",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.72,246.97c.85,0,1.54-.69,1.54-1.54s-.69-1.54-1.54-1.54h-3.26c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54h3.17",
    style: {
      fill: "#000001",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.08,
    y1: 244.73,
    x2: 211.68,
    y2: 242.01,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.13,
    y1: 244.78,
    x2: 214.48,
    y2: 241.98,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,300.81c-.06-.18-1.04-9.78-1.66-15.89",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.34,
    y1: 280.87,
    x2: 179.95,
    y2: 256.73,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.4,
    y1: 249.4,
    x2: 185.86,
    y2: 249.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.52,
    y1: 236.69,
    x2: 180.7,
    y2: 242.95,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.34,
    y1: 249.95,
    x2: 165.34,
    y2: 238.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.57,
    y1: 304.43,
    x2: 152.03,
    y2: 292.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,218.33c.46-1.09.97-1.76,1.89-2.52.53-.43,1.5-.74,2.18-.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.36,
    y1: 207.28,
    x2: 204.36,
    y2: 168.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4,
    y1: 240.54,
    x2: 213.4,
    y2: 186.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,266.27c-.12-.35-.12-47.86-.12-47.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,165.13c-.02-.28.07-.56.18-.83.68-1.6,2.38-2.7,4.11-2.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.07,
    y1: 222.21,
    x2: 190.07,
    y2: 240.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.02,268.74c.27,1.67.96,3.3,2.08,4.58s2.66,2.2,4.34,2.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,205.33v-6.82",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66,205.33l-2.88-6.18",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.95,205.33l2.88-6.18",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.51,231.27l1.54-.88.97-.75.57-1.15.48-1.98.71,2.07.93,1.41,1.1.75,1.19.44c.09.18-1.37,1.1-1.37,1.1l-1.06.93-.79,1.28-.44,1.89-.88-2.34-1.1-1.45-1.01-.57-.84-.75h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,224.21v1.33c.02,3.27,2.23,5.88,4.89,5.86h.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,224.21v1.33c0,.93-.16,1.81-.47,2.59-.24.59-.55,1.12-.93,1.58-.53.64-1.17,1.14-1.9,1.43-.48.19-.99.3-1.52.3h-.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,238.65v-1.33c-.02-3.27,2.15-5.9,4.82-5.91h.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,238.65v-1.33c-.02-3.27-2.23-5.88-4.89-5.86h-.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.31,262.97h-6.98s-.26-2.05-.26-2.05l-2.15-.26-1.25-.72-.44-.89.08-3.94-1.87-.08,1.7-4.02.8-3.04.89.98,1.87,1.52,2.23.98s1.61-.08,1.87-.18,1.52.62,1.52.62c0,0,.8,1.34.72,1.61s-.8,1.34-1.07,1.43-1.7.44-1.7.18.54,1.87.54,1.87l1.07,1.79,1.79,1.16.8.44-.18,2.59h0Z",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.07,244.36l1.73.88,1.63,1.41,1.02,1.63.57,1.81v2.08s-1.14,3.84-1.14,3.84l-.93,3.05-.44,1.31-1.81-1.23-1.24-1.06-.62-1.11-.54-1.87,1.21.07,1.14-1.1.4-1.1-.7-1.09-1.07-.68-1.14.14-1.55-.14-1.87-.76-1.87-1.52-.57-1.47.71-1.28,1.67-1.32,1.59-.61s1.5-.35,1.63-.31,2.2.44,2.2.44h.01Z",
    style: {
      fill: "#fef5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.59,328.17l-2.28,7.72v-.07c-.54,1.87-2.52,2.94-4.39,2.39l-3.34-.98c.11-.28.2-.56.3-.86.1-.31.18-.59.26-.88,1.03.31,2.05.61,3.08.92h-.04c1.06.3,2.17-.31,2.49-1.37l-.05.14,2.21-7.51",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.8,
    cy: 320.93,
    r: 22,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.8,
    cy: 320.87,
    r: 19.63,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 717.8,
    y1: 301.25,
    x2: 717.8,
    y2: 340.5,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 737.43,
    y1: 320.87,
    x2: 698.17,
    y2: 320.87,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 731.68,
    y1: 307,
    x2: 703.92,
    y2: 334.75,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 731.68,
    y1: 334.75,
    x2: 703.92,
    y2: 307,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.94,
    y1: 313.36,
    x2: 699.67,
    y2: 328.38,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 725.32,
    y1: 339,
    x2: 710.29,
    y2: 302.74,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710.29,
    y1: 339,
    x2: 725.32,
    y2: 302.74,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 699.67,
    y1: 313.36,
    x2: 735.94,
    y2: 328.38,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.81,
    cy: 320.79,
    r: 5.8,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.45,
    y: 291.97,
    width: 1.82,
    height: 41.55,
    transform: "translate(1364.72 625.49) rotate(-180)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.83,
    y: 319.98,
    width: 13.5,
    height: 1.82,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.97,295.75v-24.51c0-3.66-2.16-6.83-5.28-8.28l-7.61-.03c-3.16,1.44-5.35,4.62-5.35,8.3v24.47s18.24.08,18.24.08",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.86,
    y: 292.14,
    width: 1.82,
    height: 7.69,
    transform: "translate(1433.55 591.97) rotate(-180)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.86,292.2h3.83c0-1.03-.84-1.85-1.85-1.85h-2.03s1.04,0,1.04,0h-33.57c-1.03,0-1.85.84-1.85,1.85h36.87",
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.68,267.26c-1.05-.22-2.1-.43-3.16-.66h.04c-1.08-.21-2.14.49-2.36,1.57l.04-.14-8.3,40.71-1.79-.36,8.34-40.9v.07c.39-1.92,2.26-3.16,4.17-2.76l3.41.7c-.07.29-.15.57-.22.88-.07.31-.14.61-.19.9h.01Z",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732.26,
    y: 265.98,
    width: 11.75,
    height: 3.14,
    transform: "translate(1407.97 677.12) rotate(-168.48)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.05,304.4h34.93s0-8.66,0-8.66h-38.23s.1-.03.1-.03c-2.95,0-5.41,2.1-5.98,4.87l-.05.19-7.79,27.03,9.01,2.59,7.52-26.07",
    style: {
      fill: "#eb5b5e",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.53,327.56c-1.27-.12-2.34.44-2.68,1.65-.34,1.2.23,2.44,1.42,2.8l13.55,3.99,1.94-6.56-5.72-1.68c-2.84-.06-5.68-.13-8.5-.19h-.01Z",
    style: {
      fill: "#b27a61",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 671.12,
    y1: 334.73,
    x2: 655.86,
    y2: 330.23,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.85,
    y1: 327.76,
    x2: 668.01,
    y2: 329.88,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 664.73,
    y1: 327.78,
    x2: 665.89,
    y2: 329.9,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 662.62,
    y1: 327.74,
    x2: 663.77,
    y2: 329.85,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660.51,
    y1: 327.67,
    x2: 661.66,
    y2: 329.79,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.32,
    cy: 333.52,
    r: 7.99,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.35,
    cy: 333.53,
    r: 5.8,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.41,
    y1: 322.95,
    x2: 677.42,
    y2: 325.55,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.69,
    y: 334.3,
    width: 14.44,
    height: 2.4,
    transform: "translate(1207.59 845.56) rotate(-163.55)",
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "706.47 244.56 704.76 245.35 703.45 246.78 703.09 247.66 703.97 249.08 705.66 250.29 708.75 251.42 710.61 251.48 711.72 252.45 711.85 253.82 711.03 254.74 709.08 255 710.2 256.81 711.98 257.82 713.39 258.35 714.65 257.95 715.98 251.45 715.79 248.96 714.81 247.11 713.16 245.33 711.29 244.43 708.56 244.12 706.47 244.56",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.06,262.81v-2s-1.78,0-1.78,0c-1.15-.01-2.1-.95-2.1-2.11v-3.59s-1.83,0-1.83,0l1.72-4.15",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.07,250.95c-.03-3.86,3.18-7.04,7.02-6.98,3.85.06,7.18,3.5,7,7.38-.43,3.02-1.9,6.35-2.56,8.94v2.47",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.28,254.98c.22.08.47.14.71.14,1.06,0,1.93-.86,1.93-1.94s-.86-1.94-1.92-1.95c-.22,0-.43.04-.64.11-.02,0-.04.01-.06.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.07,247.56c1.15,2.26,3.5,3.8,6.2,3.81",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.97,247.84c.16,1.41.51,2.08,1.54,3.21",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.45,248.09c.8.94,1.85,1.66,3.04,2.08",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.25,256.36c-.6.41-1.24.71-1.9.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 704.11,
    cy: 252.12,
    r: 0.42,
    style: {
      fill: "#181716"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.2,254.96c.28,2.26,1.83,4.36,4.24,5.37",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.6,256.38c.48.92,1.19,1.75,2.08,2.4",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710.08,
    y1: 259.38,
    x2: 707.43,
    y2: 260.39,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 702.85,
    y1: 311.96,
    x2: 699.08,
    y2: 307.81,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.67,304.69c-.59,1.14-.31,2.51.61,3.32",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.54,308.3s3.44,3.79,3.47,3.83c.26.29.72.31,1.02.04.29-.26.31-.72.04-1.02-1.13-1.25-2.27-2.5-3.41-3.75",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.07,311.16c.26.29.72.31,1.02.04s.31-.72.04-1.02l-1.73-1.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.74,306.44l3.4,3.74c.26.29.72.31,1.02.04s.31-.72.04-1.02c-.91-1-1.84-1.98-2.72-3-.76-.89-.58-1.23-.03-2.17.47-.8.69-1.7.42-2.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700.92,
    y1: 299.84,
    x2: 698.62,
    y2: 304.74,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.72,285.42c.46-.78.71-1.69.71-2.67v-.04s0-14,0-14c0-2.47-2-4.46-4.46-4.46s-4.46,2-4.46,4.46v13.33s-.03.04-.03.04l-7.64,16.46,8.09,3.74,7.3-15.78.46-.98",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.39,308.45c-.07.32-.15.64-.34.9s-.52.44-.83.37c-.33-.07-.54-.42-.57-.76s.07-.67.18-.98c.17-.5.33-1,.5-1.49",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 682.5,
    y: 304.42,
    width: 21.35,
    height: 6.01,
    transform: "translate(1386.35 614.86) rotate(-180)",
    style: {
      fill: "url(#Unbenannter_Verlauf_72)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.83,
    y: 319.98,
    width: 13.5,
    height: 1.82,
    style: {
      fill: "url(#Unbenannter_Verlauf_72-2)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.86,
    y: 292.14,
    width: 1.82,
    height: 7.69,
    transform: "translate(1433.55 591.97) rotate(-180)",
    style: {
      fill: "url(#Unbenannter_Verlauf_71)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.68,267.26c-1.05-.22-2.1-.43-3.16-.66h.04c-1.08-.21-2.14.49-2.36,1.57l.04-.14-8.3,40.71-1.79-.36,8.34-40.9v.07c.39-1.92,2.26-3.16,4.17-2.76l3.41.7c-.07.29-.15.57-.22.88-.07.31-.14.61-.19.9h.01Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_70)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732.26,
    y: 265.98,
    width: 11.75,
    height: 3.14,
    transform: "translate(1407.97 677.12) rotate(-168.48)",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.59,328.17l-2.28,7.72v-.07c-.54,1.87-2.52,2.94-4.39,2.39l-3.34-.98c.11-.28.2-.56.3-.86.1-.31.18-.59.26-.88,1.03.31,2.05.61,3.08.92h-.04c1.06.3,2.17-.31,2.49-1.37l-.05.14,2.21-7.51",
    style: {
      fill: "#d6e7f4",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.8,
    cy: 320.93,
    r: 22,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.8,
    cy: 320.87,
    r: 19.63,
    style: {
      fill: "url(#Unbenannter_Verlauf_69)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 717.8,
    y1: 301.25,
    x2: 717.8,
    y2: 340.5,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 737.43,
    y1: 320.87,
    x2: 698.17,
    y2: 320.87,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 731.68,
    y1: 307,
    x2: 703.92,
    y2: 334.75,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 731.68,
    y1: 334.75,
    x2: 703.92,
    y2: 307,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.94,
    y1: 313.36,
    x2: 699.67,
    y2: 328.38,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 725.32,
    y1: 339,
    x2: 710.29,
    y2: 302.74,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710.29,
    y1: 339,
    x2: 725.32,
    y2: 302.74,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 699.67,
    y1: 313.36,
    x2: 735.94,
    y2: 328.38,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.81,
    cy: 320.79,
    r: 5.8,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.45,
    y: 291.97,
    width: 1.82,
    height: 41.55,
    transform: "translate(1364.72 625.49) rotate(-180)",
    style: {
      fill: "#d6e7f4",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.86,292.2h3.83c0-1.03-.84-1.85-1.85-1.85h-2.03s1.04,0,1.04,0h-33.57c-1.03,0-1.85.84-1.85,1.85h36.87",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.32,
    cy: 333.52,
    r: 7.99,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.35,
    cy: 333.53,
    r: 5.8,
    style: {
      fill: "url(#Unbenannter_Verlauf_69-2)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.69,
    y: 334.3,
    width: 14.44,
    height: 2.4,
    transform: "translate(1207.59 845.56) rotate(-163.55)",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "700.66 300.11 698.42 305.21 698.05 307.07 697.64 309.26 698.51 309.72 699.46 308.27 701.45 310.5 703.23 312.28 704.14 311.99 704.39 311.37 705.26 310.87 705.42 310.34 706.25 309.84 706.17 309.05 703.19 305.99 703.1 304.95 703.64 303.59 704.06 302.51 703.93 301.35 700.66 300.11",
    style: {
      fill: "#fdf2e7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_18"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 702.85,
    y1: 311.96,
    x2: 699.08,
    y2: 307.81,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.69,304.61c-.59,1.14-.54,2.36.38,3.18",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.54,308.3s3.44,3.79,3.47,3.83c.26.29.72.31,1.02.04.29-.26.31-.72.04-1.02-1.13-1.25-2.27-2.5-3.41-3.75",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.07,311.16c.26.29.72.31,1.02.04s.31-.72.04-1.02l-1.73-1.91",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.74,306.44l3.4,3.74c.26.29.72.31,1.02.04s.31-.72.04-1.02c-.91-1-1.84-1.98-2.72-3-.76-.89-.58-1.23-.03-2.17.47-.8.69-1.7.42-2.63",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700.92,
    y1: 299.84,
    x2: 698.62,
    y2: 304.74,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.72,285.42c.46-.78.71-1.69.71-2.67v-.04s0-14,0-14c0-2.47-2-4.46-4.46-4.46s-4.46,2-4.46,4.46v13.33s-.03.04-.03.04l-7.64,16.46,8.09,3.74,7.3-15.78.46-.98",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.39,308.45c-.07.32-.15.64-.34.9s-.52.44-.83.37c-.33-.07-.54-.42-.57-.76s.07-.67.18-.98c.17-.5.33-1,.5-1.49",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 675.9,
    y1: 301.46,
    x2: 668.78,
    y2: 326.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 706.69,
    y1: 268.94,
    x2: 706.69,
    y2: 280.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 711.62,
    y1: 286.87,
    x2: 705.43,
    y2: 300.2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.78,264.26c-1.87,1.14-3.27,3.07-3.77,5.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.24,280.59l-1.22-.7-.77-.59-.46-.91-.38-1.57-.56,1.64-.73,1.12-.87.59-.94.35c-.07.14,1.08.87,1.08.87l.84.73.62,1.02.35,1.5.7-1.85.87-1.15.8-.46.67-.59h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.37,275v1.06c-.02,2.58-1.77,4.66-3.88,4.65h-.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.37,275v1.06c0,.74.13,1.44.38,2.05.19.47.43.89.73,1.25.41.51.93.9,1.5,1.13.38.16.78.24,1.21.24h.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.31,286.43v-1.06c.02-2.58-1.7-4.67-3.82-4.68h-.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.31,286.43v-1.06c.02-2.58,1.77-4.66,3.88-4.65h.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_27"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "756.26 247.25 780.7 212.02 781.78 208.86 782.03 206.56 781.78 203.81 780.74 200.98 779.28 198.41 777.45 196.51 775.26 195.04 772.89 194.11 770.28 193.58 767.22 193.67 764.77 194.32 761.2 196.35 758.64 199.12 756.77 203.36 756.52 205.72 754.73 200.21 751.96 196.77 748.36 194.54 743.51 193.58 739.43 194.25 736.67 195.56 734.22 197.58 731.82 201.14 731.04 203.48 730.7 207.8 731.81 211.62 735.35 216.99 756.26 247.25",
    style: {
      fill: "url(#Unbenannter_Verlauf_61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.42,206.34c0-7.07,5.74-12.81,12.81-12.81,7.07,0,12.81,5.74,12.81,12.81,0,1.58-.29,3.08-.8,4.48-.25.67-.55,1.31-.91,1.93l-23.96,34.37",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.31,206.39c0-7.07-5.74-12.81-12.81-12.81s-12.81,5.74-12.81,12.81c0,1.58.29,3.08.8,4.48.25.67.55,1.31.91,1.93l23.94,34.32",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "798.6 230.03 798.58 227.49 794.89 227.17 793.49 225.31 793.56 221.67 792.36 221.47 791.75 220.33 792.92 219.2 793.37 217.03 794.11 214.66 799.07 213.83 799.2 214.09 799.98 215.54 801 217.32 802.72 217.36 803.76 218.43 803.94 219.82 802.96 220.85 801.21 221.25 801.31 222.92 802.47 224.64 803.65 226.15 805.46 227.19 805.65 230.44 798.6 230.03",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "802.41 224.61 802.56 224.98 804.12 226.49 805.61 226.73 808.13 217.41 807.77 215.23 806.95 213.43 805.74 212.19 803.13 210.71 800.39 210.21 797 211.36 794.75 213.31 794.54 214.08 799.35 213.96 800.43 216.82 801.36 217.45 803.02 217.65 803.94 219.48 803.57 220.81 801.9 221.56 801.06 221.38 801.14 223",
    style: {
      fill: "#b07960"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "831.51 264.31 826.51 267.88 825.83 269.84 828.32 273.36 829.51 274.6 830.91 274.37 831.32 273.93 832.51 275.05 833.47 274.42 833.56 273.56 835.03 273.76 835.35 272.41 836.33 272.62 837.03 271.51 836.45 270.85 831.51 264.31",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "774.62 234.14 768.26 228.24 767.51 227.94 767.54 228.42 767.16 228.63 767.62 229.67 767.66 230.32 769.28 232.25 769.35 232.79 768.79 233.38 766.72 233.36 765.84 233.44 764.28 235.75 770.76 238.5 774.62 234.14",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "813.04 260.56 790.75 261.13 790.66 242.01 792.05 236.03 795.96 231.76 799.22 230.48 805.65 230.44 809.82 232.28 812.58 236.29 813.86 239.56 813.04 260.56",
    style: {
      fill: "#fff6bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "790.75 261.13 813.04 260.56 813.25 264.73 829.21 306.92 816.52 307.19 801.99 277.77 786.13 311.13 775.77 306.3 791.25 265.14 790.75 261.13",
    style: {
      fill: "#58b3e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.37 307.28 816.52 307.19 818.16 309.48 823.99 309.13 823.37 307.28",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "776.16 306.33 775.14 308.28 779.8 310.51 780.58 308.66 776.16 306.33",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.99 309.13 826.63 315.71 809.34 316 807.53 315.24 807.63 313.45 808.58 312.28 818.16 309.48 823.99 309.13",
    style: {
      fill: "#d6e8f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "779.6 310.64 777.28 316.37 777.09 317.05 763.78 309.61 763.24 308.01 763.99 306.83 765.75 306.32 774.2 308.25 779.6 310.64",
    style: {
      fill: "#d6e8f4"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "814.11 241.44 831.57 264.26 824.55 269.74 813.52 255.3",
    style: {
      fill: "url(#Unbenannter_Verlauf_46)",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.48,221.62l.87-.03v3.72c0,1.21,1.01,2.15,2.26,2.11l2.95-.1v3.22s7.08-.22,7.08-.22v-3.16c.8-3.35,2.4-8.63,2.4-9.48,0-.85.13-3.24-2.03-5.38-.11-.11-2.28-2.18-5.3-1.96-3.37.25-6.85,2.47-7.46,6.69",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.6,221.62c-.52.02-.93-.37-.93-.87,0-.25.11-.48.28-.65",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.03,220.03c1.11-.75,1.21-1.94,1.21-2.9",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.02,221.26c.23.08.5.13.76.12,1.13-.03,2.06-.96,2.06-2.08s-.92-1.98-2.06-1.95c-.24,0-.47.05-.69.14-.02,0-.04.02-.06.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.49,222.83c-.67.4-1.37.69-2.08.88",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 795.4,
    cy: 218.46,
    rx: 0.47,
    ry: 0.44,
    transform: "translate(-23.48 317.59) rotate(-22.26)",
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 796.24,
    y1: 221.18,
    x2: 797.4,
    y2: 223.53,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.65,227.08c-2.3-.84-4.22-2.71-4.67-5.72",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 794.42,
    y1: 214.16,
    x2: 799.49,
    y2: 214,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.93,217.4c-.69-.9-1.18-2.01-1.38-3.35",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.37,
    cy: 206.67,
    rx: 3.65,
    ry: 3.54,
    transform: "translate(101.83 648.88) rotate(-46.76)",
    style: {
      fill: "#b07960",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 831.45,
    y1: 264.12,
    x2: 834.54,
    y2: 268.16,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.32,270.79c-.65-.85-.47-2.08.4-2.74",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.05,269.47c-.33-.42-.24-1.04.18-1.38s1.04-.28,1.37.14l2.12,2.78c.32.42.22,1.04-.22,1.38s-1.05.25-1.37-.18l-2.09-2.75h.01Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.45,270.71c-.33-.42-.24-1.04.18-1.38s1.04-.28,1.37.14l2.12,2.78c.32.42.22,1.04-.22,1.38s-1.05.25-1.37-.18l-2.09-2.75h.01Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.78,272c-.33-.42-.24-1.04.18-1.38s1.04-.28,1.37.14l2.12,2.78c.32.42.22,1.04-.22,1.38s-1.05.25-1.37-.18l-2.09-2.75h.01Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.67,270.6l2.12,2.78c.32.42.22,1.04-.22,1.38s-1.05.25-1.37-.18l-2.86-3.77",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.66,270.55c.87-.67,1.04-1.9.4-2.74",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.02,233.42c.91.28,1.91.29,2.81-.05.29-.11.59-.31.62-.6.01-.16-.05-.31-.13-.43-.41-.74-1.26-1.7-1.4-1.88-.41-.54-1.02-1.33-.76-1.94.12-.29.43-.54.75-.55.29,0,.51.19.6.28.51.48,2.8,2.68,5.91,5.73",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.06,234.93c-.66.17-1.27.04-1.86-.25",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 770.15,
    y1: 238.37,
    x2: 764.4,
    y2: 235.74,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "796.05 266.42 817.8 309 818.87 311.42",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 827.8,
    y1: 303.44,
    x2: 815.61,
    y2: 303.82,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.27,307.1l3.17,8.31-17.21.54h-.08c-1.07-.01-1.91-.84-1.9-1.78,0-.83.64-1.61,1.55-1.83,2.98-.94,5.96-1.88,8.94-2.83,2.09-.08,4.17-.18,6.27-.26",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 816.23,
    y1: 309.99,
    x2: 817,
    y2: 311.97,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 814.64,
    y1: 310.56,
    x2: 815.42,
    y2: 312.54,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 786.07,
    y1: 311.23,
    x2: 801.72,
    y2: 277.86,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 774.95,
    y1: 308.34,
    x2: 774.57,
    y2: 310.46,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.3,316.91l-13.01-7.15h.03c-.9-.54-1.18-1.66-.67-2.5.43-.73,1.39-1.1,2.27-.85,3.01.65,6.02,1.28,9.03,1.93,1.69.89,2.88,1.51,4.58,2.4",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 773.42,
    y1: 308.02,
    x2: 773.03,
    y2: 310.14,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 771.92,
    y1: 307.7,
    x2: 771.53,
    y2: 309.81,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.39,
    y1: 308.64,
    x2: 777.32,
    y2: 316.9,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 775.84,
    y1: 306.21,
    x2: 786.02,
    y2: 311.28,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 777.08,
    y1: 302.86,
    x2: 787.07,
    y2: 308.11,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.54,230.58c-4.6,1.79-7.91,6.48-7.91,11.89l.29,23.02-.96,2.6-15.03,40.5",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.98,241.74c0-5.52-3.45-10.08-8.21-11.49",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.98,241.74s-1.09,23.35-.78,23.03l.96,2.54,15.07,39.57-12.18.38",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 813.07,
    y1: 260.55,
    x2: 791.19,
    y2: 261.23,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 825.68,
    y1: 313.94,
    x2: 807.61,
    y2: 314.5,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 777.82,
    y1: 315.43,
    x2: 763.74,
    y2: 307.82,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.43,246.2l-12.88-12.11-6.07,6.46,16.13,15.16.12.12c1.51,1.42,3.93,1.31,5.4-.25l.17-.18,14.48-15.39c1.61-1.7,1.57-4.35-.1-5.91-1.66-1.56-4.3-1.43-5.9.28l-12.79,13.61",
    style: {
      fill: "#fff6bb",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.56,207.61c.19-.35.31-.74.31-1.15,0-1.33-1.14-2.37-2.56-2.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 767.93,
    y1: 230.51,
    x2: 756.36,
    y2: 247.11,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.42,206.34c0-7.07,5.74-12.81,12.81-12.81,7.07,0,12.81,5.74,12.81,12.81,0,1.58-.29,3.08-.8,4.48-.25.67-.55,1.31-.91,1.93l-11.19,16.03",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.31,206.39c0-7.07-5.74-12.81-12.81-12.81s-12.81,5.74-12.81,12.81c0,1.58.29,3.08.8,4.48.25.67.55,1.31.91,1.93l23.94,34.32",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.84,215.83c-.24-1.34-.94-2.48-2-3.35-.59-.49-1.85-1.14-2.62-1.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 798.36,
    y1: 236.64,
    x2: 788.72,
    y2: 246.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.49,253.79c-3.86-3.67-13.83-12.94-13.83-12.94",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 829.58,
    y1: 263.41,
    x2: 817.54,
    y2: 247.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 777.68,
    y1: 304.71,
    x2: 789.68,
    y2: 272.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.32,293.82c0-.19-12.77-25.09-12.77-25.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 754.66,
    y1: 242.53,
    x2: 738.56,
    y2: 219.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.7,197.68c-3.21,3.11-4.49,7.74-3.28,11.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.21,195.58c-1.9.72-3.8,2.05-5.08,3.66s-1.97,3-2.3,5.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 778.31,
    y1: 213.61,
    x2: 769.56,
    y2: 226.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.34,293.23l-1.22-.7-.77-.59-.46-.91-.38-1.57-.56,1.64-.73,1.12-.87.59-.94.35c-.07.14,1.08.87,1.08.87l.84.73.62,1.02.35,1.5.7-1.85.87-1.15.8-.46.67-.59h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.47,287.64v1.06c-.02,2.58-1.77,4.66-3.88,4.65h-.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.47,287.64v1.06c0,.74.13,1.44.38,2.05.19.47.43.89.73,1.25.41.51.93.9,1.5,1.13.38.16.78.24,1.21.24h.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.41,299.08v-1.06c.02-2.58-1.7-4.67-3.82-4.68h-.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.41,299.08v-1.06c.02-2.58,1.77-4.66,3.88-4.65h.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_31"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "552.66 266.74 557.33 270.03 553.27 275.85 552.32 276.68 550.22 277.18 548.99 276.91 532.7 266.17 537.02 263.3 537.78 263.18 537.14 261.58 536.6 260.09 536.91 259.63 537.33 259.55 538.06 259.67 539.58 263.08 539.82 264.41 539.28 265.48 549.88 270.79 552.66 266.74",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.91 263.49 537.1 265.55 537.52 266.21 539.28 265.48 540.77 266.17 538.4 269.87 532.7 266.17 536.91 263.49",
    style: {
      fill: "url(#Unbenannter_Verlauf_68)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.39,258.36l1.24-2.62h.03l2.24.23c1.11.12,2.1-.69,2.21-1.79l.36-3.41.76.07h-.11c.12.01.75.05,1.08-.37.14-.18.23-.47.11-1.11-.11-.52-.38-1.47-1.3-2.54.38-3.67-2.29-6.97-5.96-7.36-3.67-.38-6.97,2.29-7.36,5.96.19,2.13.3,4.65.49,6.78l.02.11-1.16,2.44",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.25 242.62 504.05 241.36 502.54 240.22 501.03 239.6 499.14 239.39 497.18 239.82 495.16 240.98 493.87 242.26 493.18 244.04 492.76 245.9 493.18 252.21 493.65 252.34 494.4 252.44 495.63 252.49 497.12 252.04 497.72 251.43 498.93 249.89 498.31 250.07 497.41 249.76 496.55 249.13 496.36 248.2 496.61 247.47 497.13 246.71 498.26 246.2 499.19 246.59 500.27 246.53 501.43 245.75 502.37 244.67 502.85 243.21 502.75 244.64 503.26 245.36 504.24 245.51 505.03 244.97 505.58 244.14 505.25 242.62",
    style: {
      fill: "#000001"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.28 273.83 516.16 276.17 525.72 265.9 525.62 264.76 525.86 263.7 527.56 260.89 528.17 260.47 528.76 260.84 528.9 261.47 527.73 263.83 530.3 261.94 532.85 263.51 533.4 263.4 533.93 263 533.99 262.01 534.46 262.01 534.97 261.45 535.03 260.79 536.1 260.37 536.63 261.01 536.27 261.99 536.82 262.12 537.15 263.02 536.52 263.75 529.43 268.45 529.01 269.06 519.48 281.51 518.12 282.97 516.52 283.65 514.48 283.55 513.05 282.49 511.63 280.53 509.42 277.06 514.28 273.83",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.36 258.67 463.91 259.22 462.21 259.27 460.83 258.62 459.89 257.69 452.59 243.96 446.67 236.63 446.72 236.09 446.84 235.7 447.55 235.21 447.53 234.83 447.67 234.23 448.38 233.78 448.55 233.48 448.76 232.89 449.08 232.52 449.81 232.73 455.22 239.32 455.11 237.02 455.21 236.31 455.62 235.89 456.2 236.02 456.55 236.53 456.84 239.12 456.88 240.62 456.16 241.62 464.3 253.17 469.97 252.75 470.36 258.67",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.31 262.05 505.31 261.47 485.53 252.04 484.27 251.56 469.97 252.75 470.53 261.39 479.51 260.88 469.17 283 491.43 293.5 502.06 271.42 507.1 278.93 514.25 273.89 506.31 262.05",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.8 296.6 444.3 289.95 440.16 298.5 461.89 308.86 463.63 308.95 465.13 308.02 468.13 305.21 475.9 298.2 480.88 335.64 490.71 335.55 490.52 293.35 469.74 283.35 458.8 296.6",
    style: {
      fill: "url(#Unbenannter_Verlauf_67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.39,258.36l1.24-2.62h.03l2.24.23c1.11.12,2.1-.69,2.21-1.79l.36-3.41.76.07h-.11c.12.01.75.05,1.08-.37.14-.18.23-.47.11-1.11-.11-.52-.38-1.47-1.3-2.54.38-3.67-2.29-6.97-5.96-7.36-3.67-.38-6.97,2.29-7.36,5.96.19,2.13.3,4.65.49,6.78l.02.11-1.16,2.44",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "475.95 298.45 480.78 335.56 490.7 335.63 490.52 293.3",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "504.43 266.11 491.32 293.61 468.96 282.96 479.49 260.88",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.46,
    y1: 251.9,
    x2: 505.09,
    y2: 261.24,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "479.44 260.79 470.66 261.49 469.96 252.66 484.03 251.55",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.4,251.59c.68-.11,1.39-.01,2.05.31",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.12,
    y1: 253.11,
    x2: 470.02,
    y2: 252.65,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.42,
    y1: 258.66,
    x2: 463.74,
    y2: 259.19,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.11,
    y1: 253.1,
    x2: 456.11,
    y2: 241.57,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.54,
    y1: 243.82,
    x2: 459.91,
    y2: 257.75,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67,259.2c-.79.17-1.65.08-2.44-.31-.53-.26-.92-.6-1.25-1.05",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.21,238.52c.41.5,3.9,4.73,4.31,5.24",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.03,239.14l-5.08-6.31c-.28-.35-.79-.41-1.14-.14s-.41.79-.14,1.14l3.18,3.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38,241.73c-.16-1.18.67-2.24,1.84-2.4",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.95,234.21c-.28-.35-.79-.41-1.14-.14s-.41.79-.14,1.14l2.95,3.61",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.09,235.74c-.28-.35-.79-.41-1.14-.14s-.41.79-.14,1.14l3.41,4.26",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.1,241.6c.76-.57.76-1.64.76-1.64v-.14s-.32-3.09-.32-3.09c.04-.46-.35-.77-.79-.74s-.77.42-.73.87l.23,2.44",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.82,
    y1: 243.6,
    x2: 455.49,
    y2: 242.34,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.03,
    y1: 239.32,
    x2: 452.46,
    y2: 237.35,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "482.26 260.61 479.44 260.79 470.66 261.49 469.96 252.66 484.03 251.55",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.02,
    y1: 252.65,
    x2: 464.12,
    y2: 253.11,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "462.86 255.72 464.11 253.1 456.11 241.57",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.54,
    y1: 243.82,
    x2: 459.91,
    y2: 257.75,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.21,238.52c.41.5,3.9,4.73,4.31,5.24",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.03,239.14l-5.08-6.31c-.28-.35-.79-.41-1.14-.14s-.41.79-.14,1.14l3.18,3.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38,241.73c-.16-1.18.67-2.24,1.84-2.4",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.1,241.6c.76-.57.76-1.64.76-1.64v-.14s-.32-3.09-.32-3.09c.04-.46-.35-.77-.79-.74s-.77.42-.73.87l.23,2.44",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.82,
    y1: 243.6,
    x2: 455.49,
    y2: 242.34,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.03,
    y1: 239.32,
    x2: 452.46,
    y2: 237.35,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.65,262.66c-.35-.59-.87-1.09-1.54-1.41",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.6,
    y1: 278.59,
    x2: 514.26,
    y2: 273.72,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.32,
    y1: 277.2,
    x2: 512.87,
    y2: 282.31,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.1,
    y1: 268.65,
    x2: 518.86,
    y2: 282.16,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.79,264.87c-.55.36-5.11,3.4-5.65,3.76",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.63,263.76l6.99-4.72c.37-.25.88-.17,1.13.2s.17.88-.2,1.13l-4.54,2.87",
    style: {
      fill: "#ab7152",
      stroke: "#000001",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.16,266.87c.69-.96.47-2.3-.5-2.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.39,260.49c.37-.25.88-.17,1.13.2.25.37.17.88-.2,1.13l-4.19,2.65",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.77,262.21c.37-.25.88-.17,1.13.2s.17.88-.2,1.13l-4.51,3.07",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.88,265.78c-.44-.85-.03-2.02-.03-2.02l.06-.12,1.61-2.67c.16-.42.66-.55,1.04-.33s.51.72.29,1.1l-1.25,2.11",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.87,
    y1: 268.2,
    x2: 526.41,
    y2: 266.7,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.45,
    y1: 265.2,
    x2: 530.64,
    y2: 262.66,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "506.29 262.15 514.29 273.78 506.98 278.8 501.99 271.54",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.26,
    y1: 273.72,
    x2: 517.6,
    y2: 278.59,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 516.25,
    y1: 276.26,
    x2: 525.9,
    y2: 265.85,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.87,
    y1: 268.2,
    x2: 526.41,
    y2: 266.7,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "481.4 295.72 478.6 295.63 465.81 307.52 465.58 307.72",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.81,
    y1: 296.56,
    x2: 469.8,
    y2: 283.41,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "460.83 308.38 440.21 298.55 444.41 289.73 458.78 296.58",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.55,307.73c-1.25,1.11-3.09,1.43-4.7.67",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.54,335.64c2.09.01,4.18.03,6.27.04,3.14.91,5.68,1.67,7.45,2.18.52.15,1.62.46,2.17,1.39.38.66.33,1.33.33,1.41-.01.13-.06.71-.49,1.26-.4.53-1.05.9-1.85,1.02l-13.97-.15",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.46,
    y1: 341.42,
    x2: 484.71,
    y2: 341.32,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.56,
    y1: 337.93,
    x2: 490.72,
    y2: 335.94,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.56,
    y1: 338.26,
    x2: 492.72,
    y2: 336.27,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493.46,
    y1: 338.81,
    x2: 494.64,
    y2: 336.82,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.32,
    y1: 339.41,
    x2: 496.48,
    y2: 337.41,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 484.51,
    y1: 335.69,
    x2: 484.46,
    y2: 342.74,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.89,292.89c-.9,1.88-1.79,3.78-2.69,5.66-2.15,2.48-3.92,4.45-5.12,5.84-.36.4-1.1,1.27-2.18,1.38-.75.07-1.36-.25-1.42-.3-.12-.06-.6-.36-.93-.97-.31-.59-.37-1.32-.14-2.11l6.04-12.6",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.93,
    y1: 304.89,
    x2: 437.67,
    y2: 290.65,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.7,
    y1: 296.47,
    x2: 440.01,
    y2: 298.37,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.56,
    y1: 298.14,
    x2: 438.87,
    y2: 300.05,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.26,
    y1: 299.65,
    x2: 437.57,
    y2: 301.54,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.93,
    y1: 301.07,
    x2: 436.25,
    y2: 302.97,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.86,
    y1: 292.84,
    x2: 436.49,
    y2: 289.82,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.15,
    y1: 297.06,
    x2: 482.1,
    y2: 335.17,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.13,
    y1: 298.44,
    x2: 471.24,
    y2: 284.17,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.14,
    y1: 298.43,
    x2: 443.97,
    y2: 291.02,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.12,
    y1: 268.59,
    x2: 502.16,
    y2: 271.12,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.1,246.5s-.03-.03-.05-.03c-.18-.08-.38-.15-.59-.17-1.01-.11-1.91.62-2.02,1.65s.62,1.94,1.63,2.04c.23.02.47,0,.69-.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.25,252.62c-.64-.19-1.25-.48-1.82-.87",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.81,
    cy: 247.49,
    r: 0.41,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.76,249.95c-.91,2.17-3.41,3.18-5.58,2.27",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.62,243.81c-.13.42-.31.83-.6,1.15s-.71.56-1.14.56-.88-.24-1.05-.65c-.1-.22-.11-.47-.08-.71.02-.25.05-.51.12-.76-.44,1.01-.98,2.01-1.84,2.71-.26.22-.57.4-.9.49s-.7.05-1-.13",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.29,
    y1: 280.69,
    x2: 492.43,
    y2: 291.24,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.6,
    y1: 278.11,
    x2: 493.48,
    y2: 288.75,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.04,281.9c-.66,1.11-1.9,1.85-3.23,1.85-1.33,0-2.51-.7-3.17-1.75",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.46,266.76l-4.67,3.26,3.56,5.11,1.11,1.33,1.33.74,2.08-.15,2.37-1.7,9.98-6.54,6.91-3.54.22-1.19-.82-.44s-.07-.96-.15-1.19-1.11,0-1.11,0l.52-.89-.67-.82-1.7.37.15-.22c.15-.22-.59-1.11-.59-1.11l-3.78,1.78-.89,1.63.3,1.56-11.56,6-2.59-4h0Z",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.66 267.44 591.87 272.02 599.46 266.76 590.59 254.54 589.44 253.49 587.7 252.94 563.85 252.75 562.11 254 552.86 266.94 560.23 271.89 563.35 267.51 563.48 289.65 588.62 289.52 588.66 267.44",
    style: {
      fill: "#eb5b5e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.62 289.52 563.48 289.65 556.49 303.28 555.73 304.85 555.89 307.27 556.69 309.2 567.84 327.56 577.79 324.59 568.8 306.23 576.16 294.1 585.72 335.97 596.34 336.17 588.62 289.52",
    style: {
      fill: "url(#Unbenannter_Verlauf_66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.7,336.21c-2.17.82-4.35,1.63-6.52,2.45-1.33.33-2.06,1.65-1.74,2.72.25.83,1.13,1.44,2.15,1.44h-.04,9.33s.11-.05.11-.05l2.48-1.46.3,1.51h2.29s-1.08-6.65-1.08-6.65",
    style: {
      fill: "#944621",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.76,327.68c-1.82,1.44-3.63,2.89-5.45,4.33-1.18.72-1.46,2.21-.82,3.12.5.72,1.52,1.03,2.49.72h-.04l8.87-2.87.08-.08,1.91-2.15.74,1.34.06-.02,2.12-.69-3.01-5.87",
    style: {
      fill: "#944621",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.46,252.89v-2.72c.54-2.48,1.51-4.78,2.05-7.26.43-4.52-3.16-8.17-6.95-8.07-3.21.1-6.2,2.88-6.56,6.63v.21c.07,1.26-.23,1.8-.55,2.06-.17.13-.51.33-.67.75-.04.12-.13.34-.04.58.15.42.7.52.73.52h-.07s.76,0,.76,0l.02,3.35c0,1.09.92,2.28,2.01,2.28l1.46.22h0v1.12",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "563.33 257.74 563.33 289.6 588.84 289.6 588.79 257.73",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 587.27,
    y1: 252.92,
    x2: 564.88,
    y2: 252.92,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.63,
    y1: 260.01,
    x2: 563.27,
    y2: 263.67,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.77,241.96s.03-.02.05-.02c.19-.06.39-.11.6-.11,1.01,0,1.81.8,1.82,1.82s-.8,1.84-1.8,1.84c-.24,0-.47-.04-.68-.13",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.3,247.43c.61-.22,1.2-.53,1.75-.94",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570.34,
    cy: 242.18,
    r: 0.46,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "588.85 267.78 591.9 272.03 599.31 266.72 590.85 254.9",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.84,254.89c-.78-1.2-2.13-1.98-3.66-1.98",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.19,
    y1: 270.73,
    x2: 599.33,
    y2: 266.74,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.72,
    y1: 270.01,
    x2: 598.98,
    y2: 275.94,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "601.6 273.79 602.24 270.78 613.63 264.84",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.84,
    y1: 268.41,
    x2: 603.07,
    y2: 276.83,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.03,276c.56.76,1.46,1.26,2.48,1.26.57,0,1.1-.15,1.56-.42",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.98,
    y1: 267.57,
    x2: 614.19,
    y2: 265.87,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.95,265.77c.6-.94.41-2.17-.41-2.88",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.09,
    y1: 266.7,
    x2: 615.9,
    y2: 268.36,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.34,261.66l.12-.07,2.84-1.49c.36-.29.86-.14,1.08.26s.07.9-.33,1.12l-2.48,1.37",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.69,264.78c-.06-.08-.6-1.02-.38-1.87.21-.83.89-1.18,1-1.23",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.69,263.58l2.6-1.36c.4-.2.56-.7.36-1.1s-.7-.56-1.1-.36l-2.64,1.38c-.4.21-.55.71-.34,1.11s.71.55,1.11.34h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.45,265.06l2.6-1.36c.4-.2.56-.7.36-1.1s-.7-.56-1.1-.36l-2.64,1.38c-.4.21-.55.71-.34,1.11s.71.55,1.11.34h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.26,266.6l2.6-1.36c.4-.2.56-.7.36-1.1s-.7-.56-1.1-.36l-2.64,1.38c-.4.21-.55.71-.34,1.11s.71.55,1.11.34h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "588.83 289.57 596.29 336.13 585.7 336.15 576.07 293.91 572.35 292.64",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.64,
    y1: 306.25,
    x2: 575.93,
    y2: 293.99,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.45,
    y1: 289.48,
    x2: 556.35,
    y2: 303.47,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.61 306.38 577.79 324.47 567.7 327.72 556.57 308.92",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.29,303.54c-.38.73-.59,1.57-.59,2.45,0,1.1.34,2.13.91,2.98",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "589.15 292.62 583.95 292.62 583.95 291.34 588.99 291.34",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 584.87,
    y1: 331.8,
    x2: 595.4,
    y2: 331.8,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.59,
    y1: 320.39,
    x2: 565.5,
    y2: 323.65,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.62,
    y1: 341.3,
    x2: 593.78,
    y2: 341.3,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.63,
    y1: 335,
    x2: 577.01,
    y2: 330.02,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 572.96,
    y1: 250.12,
    x2: 575.32,
    y2: 247.7,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "563.17 267.8 560.13 272.05 552.71 266.74 561.17 254.92",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.19,254.91c.78-1.2,2.13-1.98,3.66-1.98",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 549.83,
    y1: 270.75,
    x2: 552.7,
    y2: 266.76,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.31,
    y1: 270.03,
    x2: 553.04,
    y2: 275.96,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "550.44 273.81 549.78 270.81 539.3 265.33",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.19,
    y1: 268.43,
    x2: 548.96,
    y2: 276.85,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.01,276.03c-.56.76-1.46,1.26-2.48,1.26-.57,0-1.1-.15-1.56-.42",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.81,
    y1: 268.06,
    x2: 538.61,
    y2: 266.37,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.31,266.11c-.61-.93-.47-2.15.36-2.86",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.95,
    y1: 266.28,
    x2: 536.14,
    y2: 268.4,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.43,262.86l-1.28-2.93c-.11-.44-.6-.64-1.02-.47s-.61.66-.43,1.08l1.08,2.62",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.35,265.26c.06-.07.86-1.12.12-2.3",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.2,261.85l-1.81-2.31c-.28-.36-.23-.88.13-1.15s.87-.22,1.15.13l1.84,2.34c.28.35.2.87-.15,1.14s-.87.21-1.14-.15h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.89,262.87l-1.81-2.31c-.28-.36-.23-.88.13-1.15s.87-.22,1.15.13l1.84,2.34c.28.35.2.87-.15,1.14s-.87.21-1.14-.15h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.53,263.95l-1.81-2.31c-.28-.36-.23-.88.13-1.15s.87-.22,1.15.13l1.84,2.34c.28.35.2.87-.15,1.14s-.87.21-1.14-.15h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590.5,
    y1: 260.01,
    x2: 588.86,
    y2: 263.67,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M564.56,287.01v-27.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.25,
    y1: 266.5,
    x2: 561.84,
    y2: 255.99,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.61,
    y1: 296.22,
    x2: 594.68,
    y2: 334.08,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.89,
    y1: 303.27,
    x2: 563.89,
    y2: 291.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 567.81,
    y1: 325.63,
    x2: 558.41,
    y2: 309.68,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.77,
    y1: 339.43,
    x2: 585.53,
    y2: 337.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.47,
    y1: 332.4,
    x2: 568.08,
    y2: 328.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.92,
    y1: 258.13,
    x2: 597.94,
    y2: 266.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.54,
    y1: 276.34,
    x2: 525.38,
    y2: 267.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.59,
    y1: 321.41,
    x2: 489.41,
    y2: 294.19,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.93,
    y1: 306.77,
    x2: 476.79,
    y2: 295.67,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.94,
    y1: 289.38,
    x2: 502.87,
    y2: 266.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.64,
    y1: 254.07,
    x2: 482.34,
    y2: 252.82,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.81,296.68l-.67.59-.8.46-.87,1.15-.7,1.85-.35-1.5-.62-1.02-.84-.73s-1.15-.73-1.08-.87l.94-.35.87-.59.73-1.12.56-1.64.38,1.57.46.91.77.59,1.22.7h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.28,296.79h.78c2.11.01,3.85-2.06,3.88-4.65v-1.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.55,296.82h-.78c-.42,0-.83-.08-1.21-.24-.57-.23-1.09-.62-1.5-1.13-.3-.36-.54-.78-.73-1.25-.25-.61-.38-1.31-.38-2.05v-1.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.27,296.79h.78c2.12.01,3.84,2.1,3.82,4.68v1.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.54,296.82h-.78c-2.11-.01-3.85,2.06-3.88,4.65v1.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyvisualLgRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyvisual-lg-rgb.116668045039e07ba5e627a71db9458c.svg";